import { BackgroundActiveOutlined, BackgroundInActiveOutlined, BrandingActiveSvg, BrandingInactiveSvg, BRollActiveSvg, BRollInActiveSvg, ElementsActiveSVG, ElementsInActiveSVG, FilmSvgActive, FilmSvgInactive, MediaUploadActive, MediaUploadInactive, MusicActive, MusicInactive, ScriptActive, ScriptInactive, SubtitleActiveSVG, SubtitleInactiveSVG, TextOverlayActive, TextOverlayInactive, SpeakingImageAtiveSVG, SpeakingImageInactiveSVG, ShapesActiveSvg, ShapesInactiveSvg, AiToolActiveSVG, AiToolInActiveSVG, BrandKitActiveSVG, BrandKitSVG, GridTemplateSVGActive, GridTemplateSVGInactive } from "assets/svg/icon";
import { AI_VIDEO_EDITOR_DIY_ID } from "configs/AppConfig";
import { generateUniqueName } from "views/app-views/vudio/VudioUtils/commonVarible";

export const assignSelectedImages = (imagesArray = [], selectedTemplate) => {
    const groupedImages = {};

    for (const img of imagesArray) {
        if (!groupedImages[img?.image_type]) {
            groupedImages[img?.image_type] = [];
        }
        groupedImages[img?.image_type].push(img?.image);
    }

    const usageMap = {};

    selectedTemplate.upload_images = selectedTemplate?.upload_images?.map((uploadImage) => {
        if (uploadImage?.frameType == "video") {
            return uploadImage;
        }
        else {
            const pairType = uploadImage?.pair_type;
            const availableImages = groupedImages[pairType];

            if (!uploadImage?.selected_image) {
                if (availableImages && availableImages.length > 0) {
                    if (!usageMap[pairType]) usageMap[pairType] = 0;

                    const selectedIndex = usageMap[pairType] % availableImages.length;
                    uploadImage.selected_image = availableImages[selectedIndex];

                    usageMap[pairType] += 1;
                } else {
                    uploadImage.selected_image = null;
                }
                uploadImage.background = null;
            }

        }
        return uploadImage;
    });

    return selectedTemplate;
}

export const getCurrentFrameImages = (frameType, aiVideoShootsStates) => {
    const groupedImages = {};
    for (const img of aiVideoShootsStates?.images) {
        if (!groupedImages[img.image_type]) {
            groupedImages[img.image_type] = [];
        }
        groupedImages[img.image_type].push(img.image);
    }
    return groupedImages[frameType] || [];
}

export const getFrameTypeLable = (frameType) => {
    const FrameTypeUpper = frameType?.toUpperCase();
    switch (FrameTypeUpper) {
        case "F":
            return "Front";
        case "S":
            return "Side";
        case "B":
            return "Back";
        case "FC":
            return "Front Close";
        case "FS":
            return "Front Side"
        default:
            return "Unknown Frame Type";
    }
}

export const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(secs).padStart(2, '0');
    return `${paddedMinutes}:${paddedSeconds}`;
}

export function isImageUrl(url) {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)(\?.*)?$/i;
    return imageExtensions.test(url);
}

export const isDuplicateUrl = (url, localImages = []) => {
    return localImages.some(img => img.trim() === url.trim());
};

export const replaceShotTypes = (shotType) => {
    if (shotType == "OF") {
        return "F"
    }
    else if (shotType == "OS") {
        return "S"
    }
    else if (shotType == "OB") {
        return "B"
    }
    else {
        return shotType
    }
}

export const isAIVideoShoot = () => {
    const params = new URLSearchParams(window.location.search);
    if (window.location.href.includes("aiVideoEditor") || params.has("template_id")) {
        return false;
    }
    return true
}

export const getVideoDuration = async (videoUrl) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.src = videoUrl;

        video.onloadedmetadata = () => {
            const duration = Math.floor(video.duration);
            resolve(duration);
        };

        video.onerror = () => {
            reject(new Error("Failed to load video metadata."));
        };
    });
};

export const getAudioDuration = (audioUrl) => {
    return new Promise((resolve, reject) => {
        const audio = document.createElement("audio");
        audio.preload = "metadata";
        audio.src = audioUrl;

        audio.onloadedmetadata = () => {
            resolve(Math.floor(audio.duration) == 0 ? 1 : Math.floor(audio.duration));
        };

        audio.onerror = () => {
            reject(new Error("Failed to load audio metadata."));
        };
    });
};



export const VideoOutputMode = [
    {
        label: "Standard",
        value: "std"
    },
    {
        label: "Premium",
        value: "pro"
    }
]

export const VideoDuration = [
    {
        label: "5 sec",
        value: 5
    },
    {
        label: "10 sec",
        value: 10
    }
]

export const VideoDurationKlingBulkCreation = [
    {
        label: "5 s",
        value: 5
    },
    {
        label: "10 s",
        value: 10
    }
]

export const TwoFrameShotsTypes = ["FS"];

export const ScriptDefaultValues = {
    charPerSec: 23,
    volume: 100,
    speed: 1,
    subtitle: false,
    minVolume: 0,
    maxVolume: 100,
    volumeStepper: 1,
    minSpeed: 0.5,
    maxSpeed: 1.5,
    speedStepper: 0.1
}

export const dummyOverlayArray = [
    {
        id: "xyzidx",
        text: "Add Text 1",
        fontSize: 120,
        x: 5,
        y: 50,
        width: 90,
        isSelected: false,
        startTime: 0,
        endTime: 10,
        align: "center",
        rotation: 0
    },
    {
        id: "binow",
        text: "Add Text 2",
        fontSize: 120,
        x: 5,
        y: 10,
        width: 90,
        isSelected: false,
        startTime: 5,
        endTime: 10,
        align: "left",
        rotation: 0
    }
]

export const editorItems = [
    { name: "Media", activeImage: <MediaUploadActive />, inactiveImage: <MediaUploadInactive />, key: "media" },
    { name: "Brand Kit", activeImage: <BrandKitActiveSVG />, inactiveImage: <BrandKitSVG />, key: "brandKit" },
    { name: "AI Tools", activeImage: <AiToolActiveSVG />, inactiveImage: <AiToolInActiveSVG />, key: "aiTools" },
    { name: "Music", activeImage: <MusicActive />, inactiveImage: <MusicInactive />, key: "music" },
    { name: "Voiceover", activeImage: <ScriptActive />, inactiveImage: <ScriptInactive />, key: "script" },
    { name: "Stocks", activeImage: <ElementsActiveSVG />, inactiveImage: <ElementsInActiveSVG />, key: "stocks" },
    { name: "Grid & Template", activeImage: <GridTemplateSVGActive />, inactiveImage: <GridTemplateSVGInactive />, key: "gridTemplate" },
    { name: "Subtitle", activeImage: <SubtitleActiveSVG />, inactiveImage: <SubtitleInactiveSVG />, key: "subtitle" },
    { name: "Text", activeImage: <TextOverlayActive />, inactiveImage: <TextOverlayInactive />, key: "text" },
    { name: "Shapes", activeImage: <ShapesActiveSvg />, inactiveImage: <ShapesInactiveSvg />, key: "shapes" },
    // { name: "Avatar", activeImage: <AvatarActive />, inactiveImage: <AvatarInactive />, key: "avatar" },
    // { name: "Background", activeImage: <BackgroundActiveOutlined />, inactiveImage: <BackgroundInActiveOutlined />, key: "background" },
    // { name: "Branding", activeImage: <BrandingActiveSvg />, inactiveImage: <BrandingInactiveSvg />, key: "branding" },
    // { name: "Elements", activeImage: <ElementsActiveSVG />, inactiveImage: <ElementsInActiveSVG />, key: "element" },
    // { name: "B-Rolls", activeImage: <BRollActiveSvg />, inactiveImage: <BRollInActiveSvg />, key: "broll" },
]

export const defaultTextStyles = {
    title: {
        font_size: 120
    },
    subtitle: {
        font_size: 64
    },
    body_text: {
        font_size: 42
    }
}

export const SubtitleAvailableStyles = {
    text_style_1: {
        key: "text_style_1",
        color: "#FFF30F",
        outline_color: "#000000",
        background: "none",
        text_shadow_color: "none",
        active_color: "none",
        active_text_shadow_color: "none",
        showActiveTextShadow: false,
        showOutline: true,
        showBackground: false,
        showTextShadow: false,
        showActiveText: false,
    },
    text_style_2: {
        key: "text_style_2",
        color: "#FFFFFF",
        outline_color: "#333333",
        text_shadow_color: "#1F1F1F50",
        active_color: "none",
        background: "none",
        active_text_shadow_color: "none",
        showActiveTextShadow: false,
        showOutline: true,
        showBackground: false,
        showTextShadow: true,
        showActiveText: false
    },
    text_style_3: {
        key: "text_style_3",
        color: "#ffffff",
        outline_color: "#8F8F8F",
        background: "#000000",
        text_shadow_color: "#FFFFFF80",
        active_color: "none",
        active_text_shadow_color: "none",
        showActiveTextShadow: false,
        showOutline: true,
        showBackground: true,
        showTextShadow: true,
        showActiveText: false
    },
    text_style_4: {
        key: "text_style_4",
        color: "#000000",
        outline_color: "none",
        background: "none",
        text_shadow_color: "none",
        active_color: "none",
        active_text_shadow_color: "none",
        showActiveTextShadow: false,
        showOutline: false,
        showBackground: false,
        showTextShadow: false,
        showActiveText: false
    },
    text_style_5: {
        key: "text_style_5",
        color: "#FFFFFF",
        outline_color: "#333333",
        text_shadow_color: "#FFF30F50",
        active_color: "#FFF30F",
        background: "none",
        active_text_shadow_color: "none",
        showActiveTextShadow: false,
        showOutline: true,
        showBackground: false,
        showTextShadow: true,
        showActiveText: true
    },
    text_style_6: {
        key: "text_style_6",
        color: "#000000",
        outline_color: "none",
        text_shadow_color: "none",
        active_color: "#FFEB79",
        background: "none",
        active_text_shadow_color: "none",
        showActiveTextShadow: false,
        showOutline: false,
        showBackground: false,
        showTextShadow: false,
        showActiveText: true
    },
    text_style_7: {
        key: "text_style_7",
        color: "#FFFFFF",
        outline_color: "none",
        text_shadow_color: "none",
        active_color: "#00FF00",
        background: "#000000BF",
        active_text_shadow_color: "#00CC00",
        showActiveTextShadow: true,
        showOutline: false,
        showBackground: true,
        showTextShadow: false,
        showActiveText: true
    }
}

export const SubtitleTabs = [
    {
        key: 0,
        label: "Subtitle Style"
    },
    {
        key: 1,
        label: "Style Settings"
    }
]

export const Max_Video_Time = 180;

export const ElementsCategories = [
    {
        key: "gifs",
        label: "GIFs"
    },
    {
        key: "stickers",
        label: "Stickers"
    },
    {
        key: "clips",
        label: "Clips"
    },
    {
        key: "static-memes",
        label: "Memes"
    }
]

export const ElementsCategoriesTabs = [
    {
        key: "all",
        label: "All"
    },
    {
        key: "trending",
        label: "Trending"
    },
    {
        key: "recentlyUsed",
        label: "Recently Used"
    }
]

export const BrollSize = {
    default: {
        height: 400
    },
    large: {
        height: 650
    },
    medium: {
        height: 350
    },
    small: {
        height: 130
    }
}

export const BrollOrientation = {
    default: 1,
    landscape: 16 / 9,
    portrait: 3 / 4,
    sqaure: 1.4
}

export const BRollCategories = [
    {
        key: "photos",
        label: "Photos"
    },
    {
        key: "videos",
        label: "Videos"
    }
]

export const BRollCategoriesTabs = [
    {
        key: "trending",
        label: "Trending"
    },
    {
        key: "curated",
        label: "Curated"
    }
]

export const defaultVideoCanvasObject = {
    id: generateUniqueName(),
    startTime: 0,
    endTime: 5,
    duration: 5,
    background_color: "#000000",
    hasFrame: false,
    frame: null
}

export const toHexStringIfNotAlready = (color) => {
    if (typeof color === "string" && color.startsWith("#")) {
        return color;
    } else {
        return color?.toHexString?.();
    }
};

export const isDIYTemplate = (aiVideoShootsStates) => {
    return aiVideoShootsStates?.selectedTemplate?.template_id == AI_VIDEO_EDITOR_DIY_ID;
}

export const ModelOptions = [
    {
        value: "kling",
        label: "Kling",
    },
    {
        value: "bytedance",
        label: "Seedance",
    }
]

export const VideoQualityOptions = [
    {
        value: "720p",
        label: "720p",
    },
    {
        value: "1080p",
        label: "1080p",
    }
]

export const ImgToVideoDurations = [
    {
        value: "5",
        label: "5 sec",
    },
    {
        value: "10",
        label: "10 sec",
    },
    {
        value: "15",
        label: "15 sec",
    },
    {
        value: "20",
        label: "20 sec",
    },
    {
        value: "25",
        label: "25 sec",
    },
    {
        value: "30",
        label: "30 sec",
    },
];

export const ByteDanceVideoDuration = [
    {
        label: "3 sec",
        value: 3
    },
    {
        label: "4 sec",
        value: 4
    },
    {
        label: "5 sec",
        value: 5
    },
    {
        label: "6 sec",
        value: 6
    },
    {
        label: "7 sec",
        value: 7
    },
    {
        label: "8 sec",
        value: 8
    },
    {
        label: "9 sec",
        value: 9
    },
    {
        label: "10 sec",
        value: 10
    },
    {
        label: "11 sec",
        value: 11
    },
    {
        label: "12 sec",
        value: 12
    }

]

export const ByteDanceVideoDurationBulkCreation = [
    {
        label: "3 s",
        value: 3
    },
    {
        label: "4 s",
        value: 4
    },
    {
        label: "5 s",
        value: 5
    },
    {
        label: "6 s",
        value: 6
    },
    {
        label: "7 s",
        value: 7
    },
    {
        label: "8 s",
        value: 8
    },
    {
        label: "9 s",
        value: 9
    },
    {
        label: "10 s",
        value: 10
    },
    {
        label: "11 s",
        value: 11
    },
    {
        label: "12 s",
        value: 12
    }

]

export const getCreditsValue = (duration, modelType = "kling", type = "std", resolution = "720p") => {
    if (modelType == "kling") {
        if (duration == 5) {
            return type == "std" ? 6 : 12;
        }
        else if (duration == 10) {
            return type == "std" ? 12 : 24;
        }
    }
    else {
        if (type == "std") {
            return resolution == "720p" ? duration : duration * 2;
        }
        else {
            return resolution == "720p" ? duration * 4 : duration * 8;
        }
    }
}

export const ChooseAvatarTabs = [
    {
        key: "avatar",
        label: "1. Select Avatar"
    },
    {
        key: "layout",
        label: "2. Select Layout",
    }
]

export const handleDeleteFrame = (index, frameData, isDIYTemplate = true, setAiVideoShootsStates, aiVideoShootsStates, handleResetVideoTime = () => { }, setShowGenericToast, handleCloseDeleteFrameModal = () => { }) => {
    if (isDIYTemplate) {
        handleDeleteOverlayImgToVideo(setAiVideoShootsStates, frameData?.id, setShowGenericToast);
    }
    else {
        setAiVideoShootsStates((prev) => {
            const deletedFrameDuration = frameData?.duration || 5;
            const totalFrames = aiVideoShootsStates?.selectedTemplate?.upload_images?.length;
            let deletedFrameStartTime = 0;
            if (index > 0) {
                deletedFrameStartTime = aiVideoShootsStates?.selectedTemplate?.upload_images?.reduce((acc, frame, currentIndex) => {
                    if (currentIndex < index) {
                        return acc + (frame?.duration || 5);
                    }
                    return acc;
                }, 0);
            }
            else {
                deletedFrameStartTime = 0;
            }

            const updatedFrames = prev.selectedTemplate.upload_images.filter((_, i) => i != index);

            const getUpdatedData = (data = [], type) => {
                return data?.map(overlay => {

                    if (overlay?.startTime < deletedFrameStartTime) {
                        if (overlay?.endTime <= deletedFrameStartTime) {
                            return overlay;
                        }
                        else if (overlay?.endTime <= deletedFrameStartTime + deletedFrameDuration && type != "script") {
                            return {
                                ...overlay,
                                endTime: deletedFrameStartTime
                            }
                        }
                        else if (overlay?.endTime > deletedFrameStartTime + deletedFrameDuration && type != "script") {
                            return {
                                ...overlay,
                                endTime: overlay?.endTime - deletedFrameDuration
                            }
                        }
                        else if (type == "script") {
                            return null;
                        }
                    }

                    if (overlay?.startTime >= deletedFrameStartTime && overlay?.startTime < deletedFrameStartTime + deletedFrameDuration) {
                        if (overlay?.endTime <= deletedFrameStartTime + deletedFrameDuration) {
                            return null;
                        }
                        else if (overlay?.endTime > deletedFrameStartTime + deletedFrameDuration && type != "script") {
                            return {
                                ...overlay,
                                endTime: overlay?.endTime - deletedFrameDuration
                            }
                        }
                        else if (type == "script") {
                            return null;
                        }
                    }

                    if (overlay?.startTime >= deletedFrameStartTime + deletedFrameDuration && overlay?.endTime > deletedFrameStartTime + deletedFrameDuration && type != "script") {
                        return {
                            ...overlay,
                            startTime: overlay?.startTime - deletedFrameDuration,
                            endTime: overlay?.endTime - deletedFrameDuration
                        }
                    }

                    return overlay;
                })?.filter((data) => data != null) || [];
            };

            const updateScripts = (data = []) => {
                let currentTime = 0;
                const updatedItems = data.map(item => {
                    const duration = (item.endTime ?? 0) - (item.startTime ?? 0);
                    const newItem = {
                        ...item,
                        startTime: currentTime,
                        endTime: currentTime + duration,
                    };
                    currentTime += duration;
                    return newItem;
                });
                return updatedItems;
            }

            return {
                ...prev,
                selectedTemplate: {
                    ...prev.selectedTemplate,
                    upload_images: updatedFrames
                },
                templateDuration: prev.templateDuration - deletedFrameDuration,
                texts: totalFrames > 1 ? getUpdatedData(prev?.texts) : [],
                musics: totalFrames > 1 ? getUpdatedData(prev.musics) : [],
                brandings: totalFrames > 1 ? getUpdatedData(prev.brandings) : [],
                scripts: totalFrames > 1 ? updateScripts(getUpdatedData(prev?.scripts, "script")) : [],
                elements: totalFrames > 1 ? getUpdatedData(prev?.elements) : [],
                brolls: totalFrames > 1 ? getUpdatedData(prev?.brolls) : []
            };
        });
    }

    handleResetVideoTime();

    setShowGenericToast({
        status: true,
        type: "success",
        message: "Frame deleted successfully."
    });

    handleCloseDeleteFrameModal();
}

export const AI_VIDEO_SHOOT_CARD_KEY = "cinematicVideoShootNew";

export const Myntra_template_Ids = ["myntra-template-first", "myntra-template-second", "myntra-template-third", "myntra-template-fourth", "myntra-template-fifth"]

export const getDefaultGlobalStates = () => {
    return {
        povStates: {
            image_url: null,
            image_in_use_url: null,
            activePanel: ["1"],
            selectedFilmingStyle: null,
            scenes: []
        },
        createAdStates: {
            promptType: "ai",
            prompt: null,
            language: "english",
            sfx: true,
            duration: 5,
            image_url: null,
            video_url: null,
            product_url: null,
            voice: null,
            music: null,
            activePanel: ["1"],
            scenes: []
        },
        speakingImageStates: {
            uploadedImages: [],
            platform: "veo",
            selectedImage: [],
            characters: [],
            scenePrompt: null,
            veoPromptData: [
                {
                    type: "scene",
                    dialogue: null,
                    image_url: "",
                    duration: 8,
                    char_position: "center",
                    character_image: null,
                    character_id: null,
                    character_description: null,
                    sub_job_id: null,
                    video_prompt: "",
                    sfx_prompt: "",
                    negative_prompt: "",
                    show_subtitle: false,
                    is_sfx: false,
                    is_video_prompt: false
                }
            ],
            veoCharacters: [],
            speakingImagePrompt: {
                ai_mode: {
                    prompt: null,
                    language: "",
                    segmentScript: []
                },
                custom_mode: {
                    prompt: null,
                    language: "default",
                    segmentScript: []
                }
            },
            speakingImgJobId: null,
            speakingImgGeneratedScene: [],
            selectedVoice: {},
            klingPrompt: {
                manual_mode: {
                    prompt: ""
                },
                ai_mode: {
                    prompt: "",
                    language: ""
                }
            },
            klingScript: "",
            showCreateSpeakingImgBtn: false
        }
    }
}

export const getDefaultDIYStates = () => {
    // activeRowIndex is that index in which my next element will be added in that specific overlay type
    return {
        templateDuration: 0,
        background_color: "#000000",
        canvas_ratio: "9:16",
        undo: [],
        redo: [],
        global_states: getDefaultGlobalStates(),
        overlays: {
            img_to_video: {
                key: "img_to_video",
                activeRowIndex: 0,
                restricted: false,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            videos: {
                key: "videos",
                activeRowIndex: 0,
                restricted: false,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            images: {
                key: "images",
                activeRowIndex: 0,
                restricted: false,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            speaking_image: {
                key: "speaking_image",
                activeRowIndex: 0,
                restricted: true,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            scripts: {
                key: "scripts",
                activeRowIndex: 0,
                restricted: true,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            shapes: {
                key: "shapes",
                activeRowIndex: 0,
                restricted: false,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            texts: {
                key: "texts",
                activeRowIndex: 0,
                restricted: false,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            music: {
                key: "music",
                activeRowIndex: 0,
                restricted: false,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            },
            branding: {
                key: "branding",
                activeRowIndex: 0,
                restricted: true,
                data: [
                    {
                        id: generateUniqueName(),
                        isSelected: false,
                        data: []
                    }
                ]
            }
        }
    }
}

export const defaultDiyOverlayTime = 5;

export const handleAddOverlayDIY = (type, setAiVideoShootsStates, data, setShowGenericToast, setCurrentTimeSec, setScrollKey, resetTime = false) => {
    setAiVideoShootsStates((prev) => {
        const currentOverlay = prev?.diy?.overlays?.[type];
        const targetRow = currentOverlay?.data?.[currentOverlay?.activeRowIndex ?? 0];
        const currentTemplateDuration = prev?.diy?.templateDuration || 0;
        if (targetRow) {
            let newDataStartTime = 0;
            let newDataEndTime = 0;
            if (data?.startTime !== undefined && data?.endTime !== undefined) {
                newDataStartTime = data?.startTime;
                newDataEndTime = data?.endTime;
            }
            else {
                newDataStartTime = targetRow?.data[targetRow?.data?.length - 1]?.endTime || 0;
                newDataEndTime = newDataStartTime + (data?.duration || defaultDiyOverlayTime);
            }
            if (newDataEndTime > Max_Video_Time) {
                if (type == "music") {
                    if (newDataStartTime == Max_Video_Time) {
                        setShowGenericToast({
                            status: true,
                            type: "error",
                            message: `Cannot add more than ${Max_Video_Time} seconds of overlays.`
                        });
                        return prev;
                    }
                    else {
                        newDataEndTime = Max_Video_Time;
                    }
                }
                else {
                    setShowGenericToast({
                        status: true,
                        type: "error",
                        message: `Cannot add more than ${Max_Video_Time} seconds of overlays.`
                    });
                    return prev;
                }
            }
            if (setCurrentTimeSec) {
                setCurrentTimeSec(resetTime ? 0 : newDataStartTime);
            }
            const newOverlayData = {
                ...data,
                startTime: newDataStartTime,
                endTime: newDataEndTime
            };
            const updatedRow = {
                ...targetRow,
                data: [...targetRow?.data, newOverlayData]
            };
            const updatedOverlayData = currentOverlay?.data?.map((row, index) => {
                if (index == currentOverlay?.activeRowIndex) {
                    return updatedRow;
                }
                return row;
            });
            const updatedOverlay = {
                ...currentOverlay,
                data: updatedOverlayData
            };
            let updatedTemplateDuration = Math.max(currentTemplateDuration, newDataEndTime);
            const undoAction = {
                action: "ADD",
                overlayKey: type,
                overlayData: {
                    ...newOverlayData,
                    isSelected: false
                },
                overlayRowIndex: currentOverlay?.activeRowIndex
            }
            return {
                ...prev,
                diy: {
                    ...prev?.diy,
                    templateDuration: updatedTemplateDuration,
                    overlays: {
                        ...prev?.diy?.overlays,
                        [type]: updatedOverlay
                    },
                    undo: [...prev?.diy?.undo, undoAction],
                    redo: []
                }
            }
        }
        return prev;
    })
    if (type) {
        setScrollKey(type)
    }
}

export const handleUpdateOverlayDIY = (type, setAiVideoShootsStates, updatedData, setShowGenericToast) => {
    setAiVideoShootsStates((prev) => {
        const currentOverlay = prev?.diy?.overlays?.[type];
        const targetRow = currentOverlay?.data?.[currentOverlay?.activeRowIndex ?? 0];
        const currentTemplateDuration = prev?.diy?.templateDuration || 0;
        if (targetRow) {
            const currentSelectedDataIndex = targetRow?.data?.findIndex(item => item?.id === updatedData?.id);
            let updatedTemplateDuration = Math.max(currentTemplateDuration, currentSelectedDataIndex == targetRow?.data?.length - 1 ? updatedData?.endTime || 0 : targetRow?.data[targetRow?.data?.length - 1]?.endTime || 0);
            if (updatedTemplateDuration > Max_Video_Time) {
                setShowGenericToast({
                    status: true,
                    type: "error",
                    message: `Cannot update more than ${Max_Video_Time} seconds of overlays.`
                });
                return prev;
            }
            const updatedRow = {
                ...targetRow,
                data: targetRow?.data?.map((item) => item.id === updatedData.id ? { ...item, ...updatedData } : item)
            };
            const updatedOverlayData = currentOverlay?.data?.map((row, index) => {
                if (index == currentOverlay?.activeRowIndex) {
                    return updatedRow;
                }
                return row;
            });
            const updatedOverlay = {
                ...currentOverlay,
                data: updatedOverlayData
            };

            const undoList = prev?.diy?.undo || [];
            const updatedUndoList = undoList.map((data) => {
                if (data?.overlayData?.id === updatedData.id && data?.overlayKey === type) {
                    return {
                        ...data,
                        overlayData: {
                            ...data?.overlayData,
                            ...updatedData,
                            isSelected: false
                        }
                    }
                }
                else {
                    return data;
                }
            })

            const redoList = prev?.diy?.redo || [];
            const updatedRedoList = redoList.map((data) => {
                if (data?.overlayData?.id === updatedData.id && data?.overlayKey === type) {
                    return {
                        ...data,
                        overlayData: {
                            ...data?.overlayData,
                            ...updatedData,
                            isSelected: false
                        }
                    }
                }
                else {
                    return data;
                }
            })

            return {
                ...prev,
                diy: {
                    ...prev?.diy,
                    templateDuration: updatedTemplateDuration,
                    overlays: {
                        ...prev?.diy?.overlays,
                        [type]: updatedOverlay
                    },
                    undo: updatedUndoList,
                    redo: updatedRedoList
                }
            }
        }
        return prev;
    })
}

export const handleDeleteOverlayDIY = (type, setAiVideoShootsStates, deletedId, setShowGenericToast, handleResetTime) => {
    setAiVideoShootsStates((prev) => {
        const currentOverlay = prev?.diy?.overlays?.[type];
        let targetRowIndex = -1;
        for (let i = 0; i < currentOverlay?.data?.length; i++) {
            const row = currentOverlay?.data?.[i];
            const deletedItem = row?.data?.find(item => item?.id === deletedId);
            if (deletedItem) {
                targetRowIndex = i;
                break;
            }
        }
        if (targetRowIndex != -1) {
            const targetRow = currentOverlay?.data?.[targetRowIndex];
            const updatedRow = {
                ...targetRow,
                data: targetRow?.data?.filter((item) => item.id !== deletedId)
            };
            const updatedOverlayData = currentOverlay?.data?.map((row, index) => {
                if (index == targetRowIndex) {
                    return updatedRow;
                }
                return row;
            });
            const updatedOverlay = {
                ...currentOverlay,
                data: updatedOverlayData
            };

            const undoAction = {
                action: "DELETE",
                overlayKey: type,
                overlayData: {
                    ...targetRow?.data?.find(item => item?.id === deletedId),
                    isSelected: false
                },
                overlayRowIndex: targetRowIndex
            }
            return {
                ...prev,
                diy: {
                    ...prev?.diy,
                    overlays: {
                        ...prev?.diy?.overlays,
                        [type]: updatedOverlay
                    },
                    undo: [...prev?.diy?.undo, undoAction],
                    redo: []
                }
            }
        }
        else {
            setShowGenericToast({
                status: true,
                type: "error",
                message: `Failed to delete overlay.`
            });
            return prev;
        }
    })

    handleResetTime();
}

export const handleUpdateOverlayImgToVideo = (setAiVideoShootsStates, updatedData, setShowGenericToast, currentFrameId) => {
    setAiVideoShootsStates((prev) => {
        let targetRowIndex = -1;
        let targetDataIndex = -1;
        for (let i = 0; i < prev?.diy?.overlays?.img_to_video?.data?.length; i++) {
            const row = prev?.diy?.overlays?.img_to_video?.data?.[i];
            const dataIndex = row?.data?.findIndex(item => item?.id == currentFrameId);
            if (dataIndex != -1) {
                targetRowIndex = i;
                targetDataIndex = dataIndex;
                break;
            }
        }
        if (targetRowIndex != -1 && targetDataIndex != -1) {
            const previousFrameData = prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex]?.data?.[targetDataIndex];
            if (previousFrameData?.duration !== updatedData?.duration) {
                const durationDifference = (updatedData?.duration || 0) - (previousFrameData?.duration || 0);
                const updatedRowData = prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex]?.data?.map((item, index) => {
                    if (index == targetDataIndex) {
                        return {
                            ...item,
                            ...updatedData,
                            startTime: item?.startTime,
                            endTime: item?.startTime + (updatedData?.duration || 0)
                        }
                    }
                    else if (index > targetDataIndex) {
                        return {
                            ...item,
                            startTime: item?.startTime + durationDifference,
                            endTime: item?.endTime + durationDifference
                        }
                    }
                    return item;
                })
                const updatedRow = {
                    ...prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex],
                    data: updatedRowData
                };
                const updatedOverlayData = prev?.diy?.overlays?.img_to_video?.data?.map((row, index) => {
                    if (index == targetRowIndex) {
                        return updatedRow;
                    }
                    return row;
                });
                const updatedOverlay = {
                    ...prev?.diy?.overlays?.img_to_video,
                    data: updatedOverlayData
                };
                let updatedTemplateDuration = prev?.diy?.templateDuration || 0;
                updatedTemplateDuration = Math.max(updatedTemplateDuration, updatedRowData[updatedRowData.length - 1]?.endTime || 0);
                return {
                    ...prev,
                    diy: {
                        ...prev?.diy,
                        templateDuration: updatedTemplateDuration,
                        overlays: {
                            ...prev?.diy?.overlays,
                            img_to_video: updatedOverlay
                        }
                    }
                };
            }
            else {
                const updatedRowData = prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex]?.data?.map((item, index) => {
                    if (index === targetDataIndex) {
                        return {
                            ...item,
                            ...updatedData
                        }
                    }
                    return item;
                });
                const updatedRow = {
                    ...prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex],
                    data: updatedRowData
                };
                const updatedOverlayData = prev?.diy?.overlays?.img_to_video?.data?.map((row, index) => {
                    if (index == targetRowIndex) {
                        return updatedRow;
                    }
                    return row;
                });
                const updatedOverlay = {
                    ...prev?.diy?.overlays?.img_to_video,
                    data: updatedOverlayData
                };
                return {
                    ...prev,
                    diy: {
                        ...prev?.diy,
                        overlays: {
                            ...prev?.diy?.overlays,
                            img_to_video: updatedOverlay
                        }
                    }
                }
            }
        }
        else {
            setShowGenericToast({
                status: true,
                type: "error",
                message: `Failed to update frame.`
            });
            return prev;
        }
    })
}

export const handleDeleteOverlayImgToVideo = (setAiVideoShootsStates, deletedId, setShowGenericToast) => {
    setAiVideoShootsStates((prev) => {
        let targetRowIndex = -1;
        let targetDataIndex = -1;
        for (let i = 0; i < prev?.diy?.overlays?.img_to_video?.data?.length; i++) {
            const row = prev?.diy?.overlays?.img_to_video?.data?.[i];
            const dataIndex = row?.data?.findIndex(item => item?.id == deletedId);
            if (dataIndex != -1) {
                targetRowIndex = i;
                targetDataIndex = dataIndex;
                break;
            }
        }
        if (targetRowIndex != -1 && targetDataIndex != -1) {
            const previousFrameData = prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex]?.data?.[targetDataIndex];
            const durationDifference = previousFrameData?.duration || 0;
            const updatedRowData = prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex]?.data?.map((item, index) => {
                if (index == targetDataIndex) {
                    return null
                }
                else if (index > targetDataIndex) {
                    return {
                        ...item,
                        startTime: item?.startTime - durationDifference,
                        endTime: item?.endTime - durationDifference
                    }
                }
                return item;
            })
            const updatedRow = {
                ...prev?.diy?.overlays?.img_to_video?.data?.[targetRowIndex],
                data: updatedRowData?.filter(item => item != null)
            };
            const updatedOverlayData = prev?.diy?.overlays?.img_to_video?.data?.map((row, index) => {
                if (index == targetRowIndex) {
                    return updatedRow;
                }
                return row;
            });
            const updatedOverlay = {
                ...prev?.diy?.overlays?.img_to_video,
                data: updatedOverlayData
            };
            let updatedTemplateDuration = prev?.diy?.templateDuration || 0;
            updatedTemplateDuration = Math.max(updatedTemplateDuration, updatedRowData[updatedRowData.length - 1]?.endTime || 0);
            const undoAction = {
                action: "DELETE",
                overlayKey: "img_to_video",
                overlayData: {
                    ...previousFrameData,
                    isSelected: false
                },
                overlayRowIndex: targetRowIndex
            }
            return {
                ...prev,
                diy: {
                    ...prev?.diy,
                    templateDuration: updatedTemplateDuration,
                    overlays: {
                        ...prev?.diy?.overlays,
                        img_to_video: updatedOverlay
                    },
                    undo: [...prev?.diy?.undo, undoAction],
                    redo: []
                }
            };
        }
        else {
            setShowGenericToast({
                status: true,
                type: "error",
                message: `Failed to delete frame.`
            });
            return prev;
        }
    })
}

export const findOverlayFromId = (overlayType, id, aiVideoShootsStates) => {
    const currentOverlay = aiVideoShootsStates?.diy?.overlays?.[overlayType];
    let targetData = null;
    if (currentOverlay) {
        for (let i = 0; i < currentOverlay?.data?.length; i++) {
            const row = currentOverlay?.data?.[i];
            const data = row?.data?.find(item => item?.id == id);
            if (data) {
                targetData = data;
                break;
            }
        }
    }
    return targetData;
}

export const copyOverlayToDestination = (sourceOverlayType, destinationOverlayType, overlayId, updatedData = {}, setAiVideoShootsStates) => {
    setAiVideoShootsStates((prev) => {
        const sourceOverlayRows = prev?.diy?.overlays?.[sourceOverlayType]?.data;
        let sourceOverlay = null;
        if (sourceOverlayRows) {
            for (let i = 0; i < sourceOverlayRows.length; i++) {
                const found = sourceOverlayRows[i]?.data?.find(item => item?.id == overlayId);
                if (found) { sourceOverlay = found; break; }
            }
        }
        if (!sourceOverlay) return prev;

        const startTime = sourceOverlay?.startTime ?? 0;
        const endTime = sourceOverlay?.endTime ?? 0;
        const duration = endTime - startTime;

        const destOverlay = prev?.diy?.overlays?.[destinationOverlayType];
        if (!destOverlay) return prev;

        const activeRowIndex = destOverlay?.activeRowIndex ?? 0;
        if (!destOverlay?.data?.[activeRowIndex]) return prev;

        let newOverlayItem = {
            id: generateUniqueName(),
            ...updatedData,
            startTime,
            endTime,
            duration
        };

        if(destinationOverlayType == "music") {
            newOverlayItem = {
                ...newOverlayItem,
                music: {
                    ...newOverlayItem?.music,
                    duration
                }
            }
        }

        const updatedDestData = destOverlay?.data?.map((row, index) => {
            if (index === activeRowIndex) {
                return { ...row, data: [...(row?.data || []), newOverlayItem] };
            }
            return row;
        });

        return {
            ...prev,
            diy: {
                ...prev?.diy,
                overlays: {
                    ...prev?.diy?.overlays,
                    [destinationOverlayType]: {
                        ...destOverlay,
                        data: updatedDestData
                    }
                }
            }
        };
    });
};

export const addNewRow = (setAiVideoShootsStates, overlayType) => {
    setAiVideoShootsStates((prev) => {
        const currentOverlay = prev?.diy?.overlays?.[overlayType];
        if (!currentOverlay) return prev;

        const newRow = {
            id: generateUniqueName(),
            isSelected: false,
            data: []
        };
        const updatedData = [...(currentOverlay?.data || []), newRow];
        const newActiveRowIndex = updatedData.length - 1;

        return {
            ...prev,
            diy: {
                ...prev?.diy,
                overlays: {
                    ...prev?.diy?.overlays,
                    [overlayType]: {
                        ...currentOverlay,
                        activeRowIndex: newActiveRowIndex,
                        data: updatedData
                    }
                }
            }
        };
    });
};

//shapes svgs

export const Shape1 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64.75" height="64.75" fill={color} />
    </svg>
)

export const Shape2 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64.75" height="64.75" rx={"8"} fill={color} />
    </svg>
)

export const Shape3 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64.75" height="64.75" rx="32.375" fill={color} />
    </svg>
)

export const Shape4 = ({ height = "64", width = "64", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.3867 11.3159L30.8795 0.54573C31.2489 -0.178612 32.2824 -0.182696 32.6576 0.538703L38.2617 11.3159L63.4217 62.1221C63.7509 62.7868 63.2673 63.5659 62.5256 63.5659H1.00129C0.258746 63.5659 -0.224793 62.7852 0.10601 62.1204L25.3867 11.3159Z" fill={color} />
    </svg>
)

export const Shape5 = ({ height = "65", width = "47", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 47 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="47" height="65" rx="2" fill={color} />
    </svg>
)

export const Shape6 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M57.0195 32.375C76.1871 56.573 56.5712 76.1871 32.375 57.0195C8.17699 76.1871 -11.4371 56.5712 7.73046 32.375C-11.4371 8.17699 8.17885 -11.4371 32.375 7.73046C56.573 -11.4371 76.1871 8.17885 57.0195 32.375Z" fill={color} />
    </svg>
)

export const Shape7 = ({ height = "59", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 59" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53.2197 1.10549C52.8542 0.971068 52.4888 0.847828 52.1233 0.738608C52.1233 0.738608 52.1178 0.738608 52.1149 0.738608C52.0165 0.710603 51.921 0.682618 51.8226 0.654613C51.7916 0.646211 51.7634 0.637785 51.7325 0.629384C51.6538 0.60698 51.5751 0.587384 51.4964 0.567781C51.4458 0.553778 51.3952 0.542572 51.3446 0.528569C51.2827 0.511766 51.2181 0.497788 51.1562 0.483786C51.0888 0.466982 51.0212 0.450167 50.9538 0.436164C50.906 0.424962 50.8554 0.413764 50.8076 0.405363C50.726 0.38856 50.6417 0.368938 50.5602 0.352135C50.5265 0.343734 50.4899 0.338148 50.4561 0.332547C50.3577 0.312943 50.2621 0.296154 50.1637 0.27655C50.1413 0.273749 50.1188 0.268137 50.0991 0.265337C49.9866 0.245733 49.8743 0.226109 49.7618 0.209306C49.7534 0.209306 49.7449 0.209337 49.7364 0.206537C47.7404 -0.10152 45.7444 -0.0595274 43.8186 0.296138C43.813 0.296138 43.8074 0.296141 43.799 0.298942C43.4616 0.360553 43.127 0.433372 42.7952 0.514587C42.7699 0.520188 42.7446 0.525774 42.7193 0.534176C42.4016 0.61259 42.0868 0.702227 41.7747 0.800245C41.741 0.811448 41.7044 0.822648 41.6707 0.83385C41.5217 0.881459 41.37 0.931843 41.221 0.982252C41.221 0.982252 41.2153 0.982252 41.2125 0.982252C41.0578 1.03546 40.906 1.0915 40.7514 1.15031C40.7232 1.16151 40.6924 1.17271 40.6643 1.18392C40.3495 1.30434 40.0373 1.43593 39.7309 1.57316C39.7252 1.57316 39.7225 1.57596 39.7169 1.57876C38.7441 2.01845 37.8107 2.54494 36.9308 3.15265C36.7874 3.25067 36.6468 3.35151 36.5091 3.45513C36.5035 3.46073 36.4951 3.46351 36.4894 3.46911C36.3489 3.57273 36.2111 3.67635 36.0761 3.78277C36.0677 3.78837 36.0592 3.79399 36.0536 3.80239C35.9271 3.90041 35.8034 4.00122 35.6797 4.10484C35.6656 4.11604 35.6516 4.12724 35.6375 4.14124C35.5082 4.25047 35.3789 4.3625 35.2496 4.47452C35.244 4.48013 35.2383 4.48571 35.2327 4.49131C35.1118 4.60053 34.991 4.70977 34.8729 4.82179C34.8589 4.83579 34.8448 4.84699 34.8308 4.861C34.5778 5.09904 34.3331 5.34546 34.0942 5.6003C34.0857 5.60871 34.0801 5.61433 34.0717 5.62273C33.456 6.28085 32.8881 6.98657 32.3736 7.74271C32.3202 7.66429 32.264 7.58589 32.2078 7.50747C32.1853 7.47667 32.1628 7.44587 32.1431 7.41507C32.0841 7.33385 32.0249 7.25264 31.9659 7.17143C31.935 7.13222 31.9069 7.0902 31.876 7.05099C31.7776 6.91936 31.6764 6.79054 31.5752 6.66452C31.5387 6.61691 31.5021 6.5721 31.4655 6.52729C31.4093 6.45728 31.3531 6.39007 31.2941 6.32006C31.2491 6.26685 31.2069 6.21642 31.1619 6.16601C31.0775 6.068 30.9932 5.9728 30.9089 5.87759C30.8527 5.81318 30.7965 5.75155 30.7374 5.68994C30.684 5.63113 30.6278 5.57512 30.5744 5.51631C30.5181 5.4575 30.4619 5.39869 30.4029 5.33988C30.3439 5.28106 30.2876 5.22225 30.2286 5.16344C30.1414 5.07662 30.0515 4.9898 29.9643 4.90578C29.9137 4.85817 29.8631 4.81056 29.8125 4.76295C29.745 4.69854 29.6747 4.63695 29.6044 4.57254C29.5594 4.53053 29.5145 4.4913 29.4667 4.4493C29.3599 4.35688 29.253 4.26447 29.1462 4.17485C29.1012 4.13564 29.0561 4.09923 29.0083 4.06282C28.9268 3.99561 28.8453 3.92841 28.761 3.864C28.7188 3.83039 28.6795 3.79959 28.6373 3.76599C28.522 3.67637 28.404 3.58673 28.2859 3.49992C28.2493 3.47191 28.21 3.44393 28.1735 3.41592C28.0779 3.34591 27.9795 3.2759 27.8811 3.20868C27.8473 3.18348 27.8107 3.16107 27.777 3.13587C27.6505 3.04905 27.5211 2.96222 27.3918 2.87821C27.3637 2.86141 27.3357 2.84182 27.3104 2.82502C27.1952 2.7522 27.0826 2.67938 26.9674 2.60937C26.9393 2.59257 26.9112 2.57575 26.8831 2.55895C26.7453 2.47493 26.6047 2.39371 26.4641 2.3125C26.4501 2.3041 26.436 2.29851 26.4247 2.29011C26.2898 2.21449 26.1549 2.14167 26.0199 2.06885C26.0002 2.05765 25.9806 2.04925 25.9609 2.03805C25.6573 1.87842 25.3509 1.73 25.0388 1.58717C25.0304 1.58157 25.0191 1.57876 25.0107 1.57316C21.7073 0.0860819 17.9514 -0.398375 14.2348 0.346563C14.2291 0.346563 14.2264 0.346563 14.2208 0.346563C14.0999 0.371768 13.9761 0.396946 13.8552 0.424951C13.8468 0.424951 13.8384 0.427757 13.8299 0.430558C13.7119 0.458563 13.591 0.486582 13.4729 0.514587C13.4645 0.514587 13.4532 0.520162 13.4448 0.522963C13.3239 0.553768 13.203 0.584599 13.0821 0.618205C13.0736 0.618205 13.068 0.621011 13.0596 0.623811C12.5451 0.763837 12.0335 0.926267 11.5275 1.1139C2.36528 4.51653 -2.29595 14.6768 1.11984 23.8037C1.49375 24.8007 2.35686 26.8031 4.09427 29.6036C4.21235 29.794 4.33606 29.9873 4.46258 30.1833C4.70997 30.5698 4.97131 30.9674 5.25244 31.3819C8.19593 35.7311 13.0091 41.5533 20.7571 48.2634L32.3763 58.3285L43.9985 48.2634C52.486 40.912 57.4565 34.6221 60.3044 30.1693C60.7064 29.542 61.0634 28.9454 61.3839 28.3937C62.6434 26.2233 63.3125 24.6495 63.6302 23.8037C67.046 14.6768 62.3848 4.51653 53.217 1.1139L53.2197 1.10549Z" fill={color} />
    </svg>
)

export const Shape8 = ({ height = "65", width = "68", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 68 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33.7627 0L41.7329 24.5299H67.5252L46.6588 39.6902L54.6291 64.2201L33.7627 49.0598L12.8963 64.2201L20.8666 39.6902L0.000190735 24.5299H25.7924L33.7627 0Z" fill={color} />
    </svg>
)

export const Shape9 = ({ height = "61", width = "61", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.5347 0.989684C29.3071 -0.329847 31.2144 -0.329848 31.9868 0.989683L34.2004 4.77134C34.7954 5.78774 36.1354 6.07257 37.0923 5.38603L40.6527 2.83168C41.895 1.94039 43.6374 2.71615 43.8063 4.23576L44.2904 8.59085C44.4206 9.76136 45.5289 10.5666 46.6823 10.3286L50.9738 9.44326C52.4713 9.13433 53.7475 10.5517 53.2837 12.0086L51.9546 16.1841C51.5974 17.3064 52.2823 18.4928 53.4328 18.7445L57.7135 19.6812C59.2071 20.0081 59.7965 21.822 58.7802 22.9643L55.8677 26.2382C55.0849 27.1181 55.2281 28.4806 56.1767 29.1785L59.7063 31.7753C60.9379 32.6814 60.7385 34.5782 59.3455 35.2085L55.3531 37.0147C54.2801 37.5002 53.8568 38.8031 54.4395 39.8265L56.6077 43.6344C57.3643 44.9631 56.4106 46.6148 54.8817 46.624L50.4999 46.6502C49.3221 46.6573 48.4055 47.6753 48.5216 48.8473L48.9535 53.2079C49.1042 54.7294 47.5612 55.8505 46.1607 55.237L42.147 53.4787C41.0683 53.0061 39.8168 53.5633 39.4461 54.6812L38.0671 58.8405C37.586 60.2917 35.7204 60.6883 34.6905 59.5582L31.739 56.3194C30.9457 55.4489 29.5758 55.4489 28.7825 56.3194L25.831 59.5582C24.8011 60.6883 22.9355 60.2917 22.4543 58.8405L21.0753 54.6812C20.7047 53.5633 19.4532 53.0061 18.3744 53.4787L14.3608 55.237C12.9603 55.8505 11.4173 54.7294 11.568 53.2079L11.9999 48.8473C12.116 47.6753 11.1993 46.6573 10.0216 46.6502L5.63981 46.624C4.11086 46.6148 3.15723 44.9631 3.91377 43.6344L6.08197 39.8265C6.66471 38.8031 6.24138 37.5002 5.16836 37.0147L1.17603 35.2085C-0.21701 34.5782 -0.416375 32.6814 0.81519 31.7753L4.34474 29.1785C5.29338 28.4806 5.43658 27.1181 4.65378 26.2382L1.74126 22.9643C0.725 21.822 1.31438 20.0081 2.80801 19.6812L7.08863 18.7445C8.23913 18.4928 8.92411 17.3064 8.56688 16.1841L7.23777 12.0086C6.77401 10.5517 8.05022 9.13433 9.54766 9.44326L13.8392 10.3286C14.9926 10.5666 16.1009 9.76136 16.2311 8.59085L16.7152 4.23576C16.8841 2.71615 18.6265 1.94039 19.8688 2.83168L23.4292 5.38603C24.3861 6.07257 25.7261 5.78774 26.3211 4.77134L28.5347 0.989684Z" fill={color} />
    </svg>
)

export const Shape10 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32.375 0L41.1192 23.6308L64.75 32.375L41.1192 41.1192L32.375 64.75L23.6308 41.1192L0 32.375L23.6308 23.6308L32.375 0Z" fill={color} />
    </svg>
)

export const Shape11 = ({ height = "63", width = "63", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29.3205 0.63016C30.6344 -0.210079 32.3168 -0.210079 33.6307 0.63016L36.267 2.31616C37.0835 2.83834 38.0619 3.04629 39.0202 2.90136L42.1144 2.43343C43.6564 2.20023 45.1934 2.88453 46.0519 4.18652L47.7745 6.79905C48.3081 7.6082 49.1173 8.1961 50.0517 8.45349L53.0687 9.28452C54.5722 9.69868 55.698 10.949 55.9527 12.4876L56.4638 15.5749C56.6221 16.5311 57.1222 17.3973 57.8712 18.0125L60.2893 19.9988C61.4945 20.9887 62.0144 22.5888 61.6212 24.098L60.8324 27.1263C60.5881 28.0642 60.6927 29.059 61.1267 29.9256L62.5278 32.7237C63.2261 34.1182 63.0503 35.7914 62.0773 37.0103L60.125 39.4559C59.5203 40.2134 59.2112 41.1646 59.2552 42.1329L59.3971 45.259C59.4679 46.817 58.6267 48.274 57.2421 48.9917L54.4638 50.4318C53.6033 50.8779 52.934 51.6212 52.5804 52.5236L51.4385 55.4372C50.8695 56.8892 49.5084 57.8781 47.9516 57.9706L44.8277 58.1562C43.8602 58.2137 42.9465 58.6205 42.2564 59.301L40.0282 61.4983C38.9177 62.5934 37.2721 62.9432 35.8122 62.3945L32.8829 61.2934C31.9757 60.9524 30.9755 60.9524 30.0682 61.2934L27.139 62.3945C25.6791 62.9432 24.0335 62.5934 22.923 61.4983L20.6948 59.301C20.0047 58.6205 19.091 58.2137 18.1235 58.1562L14.9996 57.9706C13.4428 57.8781 12.0817 56.8892 11.5126 55.4372L10.3708 52.5236C10.0171 51.6212 9.34788 50.8779 8.4874 50.4318L5.70911 48.9917C4.32451 48.274 3.4833 46.817 3.55404 45.259L3.69598 42.1329C3.73994 41.1646 3.43087 40.2134 2.82619 39.4559L0.873861 37.0103C-0.0991107 35.7914 -0.274971 34.1182 0.42333 32.7237L1.82452 29.9256C2.25849 29.059 2.36304 28.0642 2.11873 27.1263L1.32993 24.098C0.936822 22.5888 1.45672 20.9887 2.66184 19.9988L5.07999 18.0125C5.82893 17.3973 6.32903 16.5311 6.48734 15.5749L6.99846 12.4876C7.25318 10.949 8.37894 9.69868 9.8825 9.28452L12.8995 8.45349C13.8339 8.1961 14.6431 7.6082 15.1766 6.79905L16.8993 4.18652C17.7578 2.88453 19.2948 2.20023 20.8368 2.43343L23.931 2.90136C24.8893 3.04629 25.8676 2.83834 26.6842 2.31616L29.3205 0.63016Z" fill={color} />
    </svg>
)

export const Shape12 = ({ height = "57", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 57 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.0371 0L34.2202 21.6656L56.0747 16.1875L40.4033 32.375L56.0747 48.5625L34.2202 43.0844L28.0371 64.75L21.854 43.0844L-0.000463486 48.5625L15.671 32.375L-0.000463486 16.1875L21.854 21.6656L28.0371 0Z" fill={color} />
    </svg>
)

export const Shape13 = ({ height = "65", width = "49", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 49 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M48.5625 39.4392C48.5625 53.4182 37.6931 64.75 24.2813 64.75C10.8694 64.75 0 53.4182 0 39.4392C0 25.4601 24.2813 0 24.2813 0C24.2813 0 48.5625 25.4601 48.5625 39.4392Z" fill={color} />
    </svg>

)

export const Shape14 = ({ height = "65", width = "57", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 57 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M43.8396 32.375C50.9148 27.6504 57.9656 19.6858 55.9569 16.1834C53.9563 12.681 43.5876 14.8626 35.9919 18.6768C35.4715 10.138 32.1615 0 28.1522 0C24.1429 0 20.8329 10.138 20.3124 18.6768C12.7167 14.8626 2.3562 12.681 0.347497 16.1834C-1.65308 19.6858 5.39765 27.6504 12.4647 32.375C5.38952 37.0996 -1.66121 45.0642 0.347497 48.5666C2.34807 52.069 12.7167 49.8872 20.3124 46.073C20.8329 54.6118 24.1429 64.75 28.1522 64.75C32.1615 64.75 35.4715 54.6118 35.9919 46.073C43.5876 49.8872 53.9481 52.069 55.9569 48.5666C57.9574 45.0642 50.9067 37.0996 43.8396 32.375Z" fill={color} />
    </svg>
)

export const Shape15 = ({ height = "67", width = "67", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="47" height="47" transform="matrix(-0.713065 -0.701098 -0.701098 0.713065 66.4658 32.9517)" fill={color} />
    </svg>
)

export const Shape16 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 64.75V32.375V16.1875L64.75 0V48.75L0 64.75Z" fill={color} />
    </svg>
)

export const Shape17 = ({ height = "47", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="65" width="47" height="65" rx="2" transform="rotate(90 65 0)" fill={color} />
    </svg>
)

export const Shape18 = ({ height = "64", width = "64", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.3867 52.25L30.8795 63.0202C31.2489 63.7445 32.2824 63.7486 32.6576 63.0272L38.2617 52.25L63.4217 1.44378C63.7509 0.77911 63.2673 0 62.5256 0H1.00129C0.258746 0 -0.224793 0.780712 0.10601 1.4455L25.3867 52.25Z" fill={color} />
    </svg>
)

export const Shape19 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M64.75 64.75V32.375V16.1875L0 0V48.75L64.75 64.75Z" fill={color} />
    </svg>

)

export const Shape20 = ({ height = "65", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.75 32.75L52.25 13.25L64.75 0V64.75H0L31.75 32.75Z" fill={color} />
    </svg>
)

export const Shape21 = ({ height = "32", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H32.5H48.75L65 32H16.0618L0 0Z" fill={color} />
    </svg>
)

export const Shape22 = ({ height = "32", width = "65", color = "#EBEBEC" }) => (
    <svg width={width} height={height} viewBox="0 0 65 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M65 0H32.5H16.25L0 32H48.9382L65 0Z" fill={color} />
    </svg>
)

export const shapesObj = {
    "shape1": Shape1,
    "shape2": Shape2,
    "shape3": Shape3,
    "shape4": Shape4,
    "shape5": Shape5,
    "shape6": Shape6,
    "shape7": Shape7,
    "shape8": Shape8,
    "shape9": Shape9,
    "shape10": Shape10,
    "shape11": Shape11,
    "shape12": Shape12,
    "shape13": Shape13,
    "shape14": Shape14,
    "shape15": Shape15,
    "shape16": Shape16,
    "shape17": Shape17,
    "shape18": Shape18,
    "shape19": Shape19,
    "shape20": Shape20,
    "shape21": Shape21,
    "shape22": Shape22,
};

// shapes array

export const ShapesData = [
    {
        shapeId: "shape1",
        component: Shape1,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape2",
        component: Shape2,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape3",
        component: Shape3,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape4",
        component: Shape4,
        height: 64,
        width: 64,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape5",
        component: Shape5,
        height: 65,
        width: 47,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape6",
        component: Shape6,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape7",
        component: Shape7,
        height: 59,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape8",
        component: Shape8,
        height: 65,
        width: 68,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape9",
        component: Shape9,
        height: 61,
        width: 61,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape10",
        component: Shape10,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape11",
        component: Shape11,
        height: 63,
        width: 63,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape12",
        component: Shape12,
        height: 57,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape13",
        component: Shape13,
        height: 65,
        width: 49,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape14",
        component: Shape14,
        height: 65,
        width: 57,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape15",
        component: Shape15,
        height: 67,
        width: 67,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape16",
        component: Shape16,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape17",
        component: Shape17,
        height: 47,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape18",
        component: Shape18,
        height: 64,
        width: 64,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape19",
        component: Shape19,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape20",
        component: Shape20,
        height: 65,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape21",
        component: Shape21,
        height: 32,
        width: 65,
        color: "#EBEBEC"
    },
    {
        shapeId: "shape22",
        component: Shape22,
        height: 32,
        width: 65,
        color: "#EBEBEC"
    },
]

export const handleResetOverlay = (overlayType = "img_to_video", resetAll = false, setAiVideoShootsStates, overlayRowIndex = 0) => {
    setAiVideoShootsStates((prev) => {
        const currentOverlayRows = prev?.diy?.overlays[overlayType]?.data;
        const updatedOverlayRows = currentOverlayRows?.map((overlayRow, index) => {
            if (resetAll) {
                return {
                    ...overlayRow,
                    data: []
                }
            }
            else {
                return {
                    ...overlayRow,
                    data: overlayRowIndex == index ? [] : overlayRow?.data
                }
            }
        })
        return {
            ...prev,
            diy: {
                ...prev?.diy,
                overlays: {
                    ...prev?.diy?.overlays,
                    [overlayType]: {
                        ...prev?.diy?.overlays[overlayType],
                        data: updatedOverlayRows
                    }
                }
            }
        }
    })
}
export const getMyntraTemplateTextOverlayConfig = (template_id) => {
    if (template_id == "myntra-template-first") {
        return [
            {
                id: generateUniqueName(2),
                text: "Drapping made",
                type: "title",
                align: "center",
                width: 56,
                x: 22,
                y: 40,
                fontSize: 70,
                isSelected: false,
                rotation: 0,
                color: "#FFFFFFCC",
                shadow: false,
                restricted: true,
                startTime: 4,
                endTime: 8
            },
            {
                id: generateUniqueName(2),
                text: "easy chic",
                type: "title",
                align: "center",
                width: 56,
                x: 22,
                y: 45,
                fontSize: 80,
                isSelected: false,
                rotation: 0,
                color: "#FFFFFF",
                shadow: false,
                restricted: true,
                startTime: 4,
                endTime: 8
            },
            {
                id: generateUniqueName(2),
                text: "Effortless flair",
                type: "title",
                align: "left",
                width: 55,
                x: 45,
                y: 12,
                fontSize: 70,
                isSelected: false,
                rotation: 0,
                color: "#333333",
                shadow: false,
                restricted: true,
                startTime: 8,
                endTime: 12
            },
            {
                id: generateUniqueName(2),
                text: "tinkling latkan",
                type: "title",
                align: "left",
                width: 55,
                x: 45,
                y: 17,
                fontSize: 80,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 8,
                endTime: 12
            },
        ]
    }
    else if (template_id == "myntra-template-third") {
        return [
            {
                id: generateUniqueName(2),
                text: "SECOND SKIN ENERGY",
                type: "title",
                align: "center",
                width: 60,
                x: 20,
                y: 35,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#FFFFFF",
                shadow: false,
                restricted: true,
                startTime: 4,
                endTime: 8
            },
            {
                id: generateUniqueName(2),
                text: "ADAPTIVE DURABLE DENIM",
                type: "title",
                align: "center",
                width: 60,
                x: 20,
                y: 35,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#FFFFFF",
                shadow: false,
                restricted: true,
                startTime: 12,
                endTime: 16
            },
            {
                id: generateUniqueName(2),
                text: "EDGY FRAY GAME",
                type: "title",
                align: "center",
                width: 40,
                x: 30,
                y: 35,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#FFFFFF",
                shadow: false,
                restricted: true,
                startTime: 17,
                endTime: 20
            }
        ]
    }
    else if (template_id == "myntra-template-fourth") {
        return [
            {
                id: generateUniqueName(2),
                text: "PURPLE",
                type: "title",
                align: "left",
                width: 96,
                x: 2,
                y: 8,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 4,
                endTime: 8
            },
            {
                id: generateUniqueName(2),
                text: "POP",
                type: "title",
                align: "left",
                width: 96,
                x: 2,
                y: 15,
                fontSize: 90,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 4,
                endTime: 8
            },
            {
                id: generateUniqueName(2),
                text: "SQUARED",
                type: "title",
                align: "left",
                width: 96,
                x: 2,
                y: 8,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 9,
                endTime: 12
            },
            {
                id: generateUniqueName(2),
                text: "STATEMENT",
                type: "title",
                align: "left",
                width: 96,
                x: 2,
                y: 15,
                fontSize: 90,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 9,
                endTime: 12
            },
            {
                id: generateUniqueName(2),
                text: "SUN-SAFE",
                type: "title",
                align: "left",
                width: 96,
                x: 2,
                y: 8,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 13,
                endTime: 16
            },
            {
                id: generateUniqueName(2),
                text: "UV-PROTECTION",
                type: "title",
                align: "left",
                width: 96,
                x: 2,
                y: 15,
                fontSize: 90,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 13,
                endTime: 16
            }
        ]
    }
    else if (template_id == "myntra-template-fifth") {
        return [
            {
                id: generateUniqueName(2),
                text: "16 INCH",
                type: "title",
                align: "left",
                width: 90,
                x: 5,
                y: 80,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 8,
                endTime: 13
            },
            {
                id: generateUniqueName(2),
                text: "LAPTOP LAYER",
                type: "title",
                align: "left",
                width: 90,
                x: 5,
                y: 85,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 8,
                endTime: 13
            },
            {
                id: generateUniqueName(2),
                text: "CUSHIONED",
                type: "title",
                align: "left",
                width: 92,
                x: 4,
                y: 4,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 13,
                endTime: 17
            },
            {
                id: generateUniqueName(2),
                text: "COMFORT",
                type: "title",
                align: "left",
                width: 92,
                x: 4,
                y: 9,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 13,
                endTime: 17
            },
            {
                id: generateUniqueName(2),
                text: "WATERPROOF",
                type: "title",
                align: "left",
                width: 56,
                x: 22,
                y: 80,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 17,
                endTime: 21
            },
            {
                id: generateUniqueName(2),
                text: "WONDER",
                type: "title",
                align: "left",
                width: 56,
                x: 22,
                y: 85,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 17,
                endTime: 21
            },
            {
                id: generateUniqueName(2),
                text: "ON-THE-GO",
                type: "title",
                align: "left",
                width: 80,
                x: 10,
                y: 80,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 22,
                endTime: 24
            },
            {
                id: generateUniqueName(2),
                text: "UTILITY POCKETS",
                type: "title",
                align: "left",
                width: 80,
                x: 10,
                y: 85,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 22,
                endTime: 24
            }
        ]
    }
    else if (template_id == "myntra-template-sixth") {
        return [
            {
                id: generateUniqueName(2),
                text: "Rebel",
                type: "title",
                align: "left",
                width: 95,
                x: 5,
                y: 80,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 3,
                endTime: 6
            },
            {
                id: generateUniqueName(2),
                text: "LEATHERETTE",
                type: "title",
                align: "left",
                width: 95,
                x: 5,
                y: 87,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#111111",
                shadow: false,
                restricted: true,
                startTime: 3,
                endTime: 6
            },
            {
                id: generateUniqueName(2),
                text: "Chunky",
                type: "title",
                align: "left",
                width: 50,
                x: 50,
                y: 40,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 7,
                endTime: 9
            },
            {
                id: generateUniqueName(2),
                text: "BOOTS",
                type: "title",
                align: "left",
                width: 50,
                x: 50,
                y: 47,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 7,
                endTime: 9
            },
            {
                id: generateUniqueName(2),
                text: "Buckle",
                type: "title",
                align: "left",
                width: 92,
                x: 8,
                y: 40,
                fontSize: 120,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 11,
                endTime: 13
            },
            {
                id: generateUniqueName(2),
                text: "CORE",
                type: "title",
                align: "left",
                width: 92,
                x: 8,
                y: 47,
                fontSize: 100,
                isSelected: false,
                rotation: 0,
                color: "#ffffff",
                shadow: false,
                restricted: true,
                startTime: 11,
                endTime: 13
            },
        ]
    }
    return []
}

export const getFinalOverlayType = (overlayType) => {
    if (overlayType == "speaking_image_cc") {
        return "speaking_image"
    }
    else if (overlayType == "avatars" || overlayType == "scripts_cc") {
        return "scripts"
    }
    else {
        return overlayType;
    }
}


export const AvaialableFonts = [
    {
        "_id": "68071af3034b35edb4371ce8",
        "name": "Open-sans",
        "displayName": "Open-sans",
        "variants": [
            {
                "style": "regular",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/open-sans/OpenSans-Regular.ttf"
            },
            {
                "style": "bold",
                "weight": "bold",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/open-sans/OpenSans-Bold.ttf"
            },
            {
                "style": "italic",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/open-sans/OpenSans-Italic.ttf"
            }
        ]
    },
    {
        "_id": "68071a0b034b35edb4371ce4",
        "name": "Lato",
        "displayName": "Lato",
        "variants": [
            {
                "style": "regular",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/lato/Lato-Regular.ttf"
            },
            {
                "style": "bold",
                "weight": "bold",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/lato/Lato-Bold.ttf"
            },
            {
                "style": "italic",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/lato/Lato-Italic.ttf"
            }
        ]
    },
    {
        "_id": "68071a8a034b35edb4371ce6",
        "name": "Pacifico",
        "displayName": "Pacifico",
        "variants": [
            {
                "style": "regular",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/pacifico/Pacifico.ttf"
            }
        ]
    },
    {
        "_id": "680719a0034b35edb4371ce2",
        "name": "Roboto",
        "displayName": "Roboto",
        "variants": [
            {
                "style": "regular",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/Roboto/Roboto-Regular.ttf"
            },
            {
                "style": "bold",
                "weight": "bold",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/Roboto/Roboto-Bold.ttf"
            },
            {
                "style": "italic",
                "weight": "normal",
                "url": "https://lively-cms-assets.s3.ap-south-1.amazonaws.com/fonts/Roboto/Roboto-Italic.ttf"
            }
        ]
    }
]

export const Global_Style_Subtitle = {
    style: "text_style_1",
    color: SubtitleAvailableStyles["text_style_1"]?.color,
    active_color: SubtitleAvailableStyles["text_style_1"]?.active_color,
    font: AvaialableFonts[0],
    font_style: AvaialableFonts[0]?.variants[0],
    align: "center",
    width: 90,
    x: 5,
    y: 80,
    fontSize: 60,
    rotation: 0,
    outlineColor: SubtitleAvailableStyles["text_style_1"]?.outline_color,
    backgroundColor: SubtitleAvailableStyles["text_style_1"]?.background,
    textShadowColor: SubtitleAvailableStyles["text_style_1"]?.text_shadow_color,
    activeTextShadowColor: SubtitleAvailableStyles["text_style_1"]?.active_text_shadow_color,
    showOutline: SubtitleAvailableStyles["text_style_1"]?.showOutline,
    showBackground: SubtitleAvailableStyles["text_style_1"]?.showBackground,
    showTextShadow: SubtitleAvailableStyles["text_style_1"]?.showTextShadow,
    showActiveText: SubtitleAvailableStyles["text_style_1"]?.showActiveText,
    showActiveTextShadow: SubtitleAvailableStyles["text_style_1"]?.showActiveTextShadow
}

export const isTypingInInput = () => {
    const activeEl = document.activeElement;

    if (!activeEl) return false;

    return (
        activeEl.tagName === "INPUT" ||
        activeEl.tagName === "TEXTAREA" ||
        activeEl.isContentEditable
    );
};


export const getMediaType = (category = "") => {
    const videoCategories = [
        'IVC',
        'ai_feed',
        'ai_image_feed',
        'ai_video_shoot',
        'auto',
        'instagram',
        'live_stream_chunks',
        'review',
        'self'
    ]

    const imageCategories = ['ai_background_replacer', 'face_swap', 'image', 'vton']

    if (videoCategories.includes(category)) {
        return "video"
    }
    else if (imageCategories.includes(category)) {
        return "image"
    }
    return "video"
}

export const Canvas_Size = {
    "9:16": {
        height: 1920,
        width: 1080
    },
    "16:9": {
        height: 1920,
        width: 3412
    },
    "1:1": {
        height: 1920,
        width: 1920
    },
    "2:3": {
        height: 1920,
        width: 1280
    },
    "4:5": {
        height: 1920,
        width: 1536
    }
}

const pxToPercent = (valuePx, totalPx) => Number(((valuePx / totalPx) * 100).toFixed(2));


export const getFitOverlaySize = (currentCanvasRatio = "9:16", overlayCanvasRatio = "9:16") => {
    let sizeConfig = {
        x: 0,
        y: 0,
        height: 1920,
        width: 1080
    }
    if (currentCanvasRatio == "4:5") {
        if (overlayCanvasRatio == "16:9") {
            sizeConfig.y = 528;
            sizeConfig.height = 864;
            sizeConfig.width = 1536;
        }
        else if (overlayCanvasRatio == "1:1") {
            sizeConfig.y = 192;
            sizeConfig.height = 1536;
            sizeConfig.width = 1536;
        }
        else if (overlayCanvasRatio == "2:3") {
            sizeConfig.x = 128;
            sizeConfig.height = 1920;
            sizeConfig.width = 1280;
        }
        else if (overlayCanvasRatio == "9:16") {
            sizeConfig.x = 228;
        }
        else {
            sizeConfig = {
                x: 0,
                y: 0,
                height: 1920,
                width: 1536
            }
        }
    }
    else if (currentCanvasRatio == "16:9") {
        if (overlayCanvasRatio == "9:16") {
            sizeConfig.x = 1166;
        }
        else if (overlayCanvasRatio == "1:1") {
            sizeConfig.x = 746;
            sizeConfig.width = 1920;
        }
        else if (overlayCanvasRatio == "2:3") {
            sizeConfig.x = 1066;
            sizeConfig.width = 1280;
        }
        else if (overlayCanvasRatio == "4:5") {
            sizeConfig.x = 938;
            sizeConfig.width = 1536;
        }
        else {
            sizeConfig.x = 0;
            sizeConfig.y = 0;
            sizeConfig.width = 3412;
            sizeConfig.height = 1920;
        }
    }
    else if (currentCanvasRatio == "1:1") {
        if (overlayCanvasRatio == "9:16") {
            sizeConfig.x = 420;
        }
        else if (overlayCanvasRatio == "16:9") {
            sizeConfig.y = 420;
            sizeConfig.width = 1920;
            sizeConfig.height = 1080;
        }
        else if (overlayCanvasRatio == "2:3") {
            sizeConfig.x = 320;
            sizeConfig.width = 1280;
        }
        else if (overlayCanvasRatio == "4:5") {
            sizeConfig.x = 192;
            sizeConfig.width = 1536;
        }
        else {
            sizeConfig.x = 0;
            sizeConfig.y = 0;
            sizeConfig.width = 1920;
            sizeConfig.height = 1920;
        }
    }
    else if (currentCanvasRatio == "2:3") {
        if (overlayCanvasRatio == "9:16") {
            sizeConfig.x = 100;
        }
        else if (overlayCanvasRatio == "16:9") {
            sizeConfig.y = 600;
            sizeConfig.width = 1280;
            sizeConfig.height = 720;
        }
        else if (overlayCanvasRatio == "4:5") {
            sizeConfig.y = 160;
            sizeConfig.width = 1280;
            sizeConfig.height = 1600;
        }
        else if (overlayCanvasRatio == "1:1") {
            sizeConfig.y = 320;
            sizeConfig.width = 1280;
            sizeConfig.height = 1280;
        }
        else {
            sizeConfig.x = 0;
            sizeConfig.y = 0;
            sizeConfig.height = 1920;
            sizeConfig.width = 1280;
        }
    }
    else {
        if (overlayCanvasRatio == "16:9") {
            sizeConfig.y = 661;
            sizeConfig.height = 608;
        }
        else if (overlayCanvasRatio == "1:1") {
            sizeConfig.y = 425;
            sizeConfig.height = 1080;
        }
        else if (overlayCanvasRatio == "2:3") {
            sizeConfig.y = 155;
            sizeConfig.height = 1620;
        }
        else if (overlayCanvasRatio == "4:5") {
            sizeConfig.y = 290;
            sizeConfig.height = 1350;
        }
        else {
            sizeConfig = {
                x: 0,
                y: 0,
                height: 1920,
                width: 1080
            }
        }
    }
    return {
        ...sizeConfig,
        x: pxToPercent(sizeConfig?.x, Canvas_Size[currentCanvasRatio]?.width),
        y: pxToPercent(sizeConfig?.y, Canvas_Size[currentCanvasRatio]?.height)
    };
}

export const getFillOverlaySize = (canvasRatio = "9:16") => {
    return {
        x: 0,
        y: 0,
        height: Canvas_Size[canvasRatio]?.height,
        width: Canvas_Size[canvasRatio]?.width
    }
}

export const getCanvasSize = (canvasRatio = "9:16") => {
    return {
        ...Canvas_Size[canvasRatio]
    }
}

export const getWidthScaleFactor = (aspectRatio = "9:16") => {
    const SCALE_MAP = {
        "9:16": 9 / 16,   // 0.5625
        "4:5": 4 / 5,    // 0.8
        "2:3": 2 / 3,    // 0.6667
        "1:1": 1,        // 1
        "16:9": 16 / 9    // 1.7778
    };

    return SCALE_MAP[aspectRatio] ?? (9 / 16);
};

const ASPECT_RATIOS = {
    "9:16": 9 / 16,
    "16:9": 16 / 9,
    "1:1": 1,
    "4:5": 4 / 5,
    "2:3": 2 / 3
};

const getClosestAspectRatio = (width, height) => {
    const w = Number(width);
    const h = Number(height);

    if (!w || !h) return "9:16";

    const ratio = w / h;

    // 1️⃣ Exact / near-exact match first
    for (const [key, value] of Object.entries(ASPECT_RATIOS)) {
        if (Math.abs(ratio - value) < 0.02) {
            return key;
        }
    }

    // 2️⃣ Fallback: closest match
    let closest = "9:16";
    let minDiff = Infinity;

    for (const [key, value] of Object.entries(ASPECT_RATIOS)) {
        const diff = Math.abs(ratio - value);
        if (Number.isFinite(diff) && diff < minDiff) {
            minDiff = diff;
            closest = key;
        }
    }

    return closest;
};

export const getImageAspectRatioEnum = async (imageUrl) => {
    try {
        return await new Promise((resolve, reject) => {
            const img = new Image();
            // img.crossOrigin = "anonymous";

            img.onload = () => {
                const { naturalWidth, naturalHeight } = img;
                resolve(getClosestAspectRatio(naturalWidth, naturalHeight));
            };

            img.onerror = () => reject("Image load error");
            img.src = imageUrl;
        });
    } catch (error) {
        console.error("Image ratio error:", error);
        return "9:16"; // fallback
    }
};

export const getVideoAspectRatioEnum = async (videoUrl) => {
    try {
        return await new Promise((resolve, reject) => {
            const video = document.createElement("video");
            // video.crossOrigin = "anonymous";
            video.preload = "metadata";

            video.onloadedmetadata = () => {
                resolve(
                    getClosestAspectRatio(video.videoWidth, video.videoHeight)
                );
            };

            video.onerror = () => reject("Video load error");
            video.src = videoUrl;
            video.load();
        });
    } catch {
        return "9:16";
    }
};

export const handleNewCanvasRatioChange = (newCanvasRatio, setAiVideoShootsStates) => {
    setAiVideoShootsStates((prev) => {
        //img_to_video
        const currentImageToVideoData = prev?.diy?.overlays["img_to_video"]?.data;
        const updatedImageToVideoData = currentImageToVideoData?.map((overlayRow) => {
            const currentOverlayRowData = overlayRow?.data;
            const updatedOverlayRowData = currentOverlayRowData?.map((overlayData) => {
                let data = {
                    ...overlayData
                }
                if (data.hasOwnProperty("currentFit")) {
                    const currentFitData = data?.currentFit;
                    if (currentFitData == "fit") {
                        const sizeConfig = getFitOverlaySize(newCanvasRatio, data?.aspect_ratio || "9:16");
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                    else if (currentFitData == "fill") {
                        const sizeConfig = getFillOverlaySize(newCanvasRatio);
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                }
                return data;
            })
            return {
                ...overlayRow,
                data: updatedOverlayRowData
            }
        })

        //images
        const currentImagesData = prev?.diy?.overlays["images"]?.data;
        const updatedImagesData = currentImagesData?.map((overlayRow) => {
            const currentOverlayRowData = overlayRow?.data;
            const updatedOverlayRowData = currentOverlayRowData?.map((overlayData) => {
                let data = {
                    ...overlayData
                }
                if (data.hasOwnProperty("currentFit")) {
                    const currentFitData = data?.currentFit;
                    if (currentFitData == "fit") {
                        const sizeConfig = getFitOverlaySize(newCanvasRatio, data?.aspect_ratio || "9:16");
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                    else if (currentFitData == "fill") {
                        const sizeConfig = getFillOverlaySize(newCanvasRatio);
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                }
                return data;
            })
            return {
                ...overlayRow,
                data: updatedOverlayRowData
            }
        })

        //videos
        const currentVideosData = prev?.diy?.overlays["videos"]?.data;
        const updatedVideosData = currentVideosData?.map((overlayRow) => {
            const currentOverlayRowData = overlayRow?.data;
            const updatedOverlayRowData = currentOverlayRowData?.map((overlayData) => {
                let data = {
                    ...overlayData
                }
                if (data.hasOwnProperty("currentFit")) {
                    const currentFitData = data?.currentFit;
                    if (currentFitData == "fit") {
                        const sizeConfig = getFitOverlaySize(newCanvasRatio, data?.aspect_ratio || "9:16");
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                    else if (currentFitData == "fill") {
                        const sizeConfig = getFillOverlaySize(newCanvasRatio);
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                }
                return data;
            })
            return {
                ...overlayRow,
                data: updatedOverlayRowData
            }
        })

        //speaking video
        const currentSpeakingVideosData = prev?.diy?.overlays["speaking_image"]?.data;
        const updatedSpeakingVideosData = currentSpeakingVideosData?.map((overlayRow) => {
            const currentOverlayRowData = overlayRow?.data;
            const updatedOverlayRowData = currentOverlayRowData?.map((overlayData) => {
                let data = {
                    ...overlayData
                }
                if (data.hasOwnProperty("currentFit")) {
                    const currentFitData = data?.currentFit;
                    if (currentFitData == "fit") {
                        const sizeConfig = getFitOverlaySize(newCanvasRatio, data?.aspect_ratio || "9:16");
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                    else if (currentFitData == "fill") {
                        const sizeConfig = getFillOverlaySize(newCanvasRatio);
                        data.x = sizeConfig.x;
                        data.y = sizeConfig.y;
                        data.height = sizeConfig.height;
                        data.width = sizeConfig.width;
                    }
                }
                return data;
            })
            return {
                ...overlayRow,
                data: updatedOverlayRowData
            }
        })

        return {
            ...prev,
            diy: {
                ...prev?.diy,
                canvas_ratio: newCanvasRatio,
                overlays: {
                    ...prev?.diy?.overlays,
                    "img_to_video": {
                        ...prev?.diy?.overlays["img_to_video"],
                        data: updatedImageToVideoData
                    },
                    "images": {
                        ...prev?.diy?.overlays["images"],
                        data: updatedImagesData
                    },
                    "videos": {
                        ...prev?.diy?.overlays["videos"],
                        data: updatedVideosData
                    },
                    "speaking_image": {
                        ...prev?.diy?.overlays["speaking_image"],
                        data: updatedSpeakingVideosData
                    }
                }
            }
        }
    })
}

export const getTabVisibility = () => {
    return document.visibilityState === "visible";
};

export const checkBlockGenerating = (aiVideoShootsStates) => {
    const generatingOverlays = aiVideoShootsStates?.diy?.overlays || {};
    for (const overlayKey in generatingOverlays) {
        const overlay = generatingOverlays[overlayKey];
        const overlayRows = overlay?.data || [];
        for (const overlayRow of overlayRows) {
            const overlayRowData = overlayRow?.data || [];
            for (const overlayData of overlayRowData) {
                if (overlayData?.status == "GENERATING") {
                    return true;
                }
            }
        }
    }
    return false;
}

export const handleResetTimelineData = (aiVideoShootsStates, setAiVideoShootsStates) => {
    const currentOverlays = aiVideoShootsStates?.diy?.overlays || {};
    const updatedOverlays = {};
    for (const overlayKey in currentOverlays) {
        const overlay = currentOverlays[overlayKey];
        updatedOverlays[overlayKey] = {
            ...overlay,
            data: overlay?.data?.length > 0 ? [{ ...overlay?.data[0], data: [] }] : []
        }
    }
    setAiVideoShootsStates((prev) => {
        return {
            ...prev,
            diy: {
                ...prev?.diy,
                templateDuration: 0,
                overlays: {
                    ...updatedOverlays
                },
                undo: [],
                redo: []
            }
        }
    })
}

// structure poped data

// const data = {
//     action: "ADD" | "DELETE",
//     overlayKey: "",
//     overlayData: {},
//     overlayRowIndex: 0,
//     deletedOverlayIndex: 0 // only for delete action
// }


export const handleUndoClick = (aiVideoShootsStates, setAiVideoShootsStates, setShowGenericToast, handleResetVideoTime) => {
    const currentUndoStates = aiVideoShootsStates?.diy?.undo || [];
    if (currentUndoStates.length > 0) {
        const lastUndoState = currentUndoStates[currentUndoStates.length - 1];
        const undoStateType = lastUndoState?.action || "ADD";
        const { overlayKey, overlayData, overlayRowIndex } = lastUndoState;
        const overlayId = overlayData?.id;

        if (undoStateType == "ADD") {
            let updatedOverlayData = null;
            if (overlayKey && overlayData) {
                const currentOverlayData = aiVideoShootsStates?.diy?.overlays?.[overlayKey]?.data || [];
                const targetOverlayRow = currentOverlayData[overlayRowIndex] || {};
                const targetOverlayRowData = targetOverlayRow?.data || [];
                updatedOverlayData = targetOverlayRowData.find((item) => item?.id == overlayId);
                if (updatedOverlayData) {
                    const filteredOverlayRowData = targetOverlayRowData.filter((item) => item?.id != overlayId);
                    const updatedOverlayRow = {
                        ...targetOverlayRow,
                        data: filteredOverlayRowData
                    }
                    const updatedOverlayRows = currentOverlayData.map((row, index) => {
                        if (index == overlayRowIndex) {
                            return updatedOverlayRow;
                        }
                        return row;
                    })

                    const updatedRedoState = {
                        action: "ADD",
                        overlayKey: overlayKey,
                        overlayData: updatedOverlayData,
                        overlayRowIndex: overlayRowIndex
                    }
                    setAiVideoShootsStates((prev) => {
                        return {
                            ...prev,
                            diy: {
                                ...prev?.diy,
                                overlays: {
                                    ...prev?.diy?.overlays,
                                    [overlayKey]: {
                                        ...prev?.diy?.overlays?.[overlayKey],
                                        data: updatedOverlayRows
                                    }
                                },
                                undo: currentUndoStates.slice(0, currentUndoStates.length - 1),
                                redo: [...(prev?.diy?.redo || []), updatedRedoState]
                            }
                        }
                    })
                    handleResetVideoTime();
                }
                else {
                    setShowGenericToast({
                        message: "No more undo steps available",
                        status: true,
                        type: "danger"
                    });
                    return;
                }
            }
            else {
                setShowGenericToast({
                    message: "No more undo steps available",
                    status: true,
                    type: "danger"
                });
                return;
            }
        }
        else if (undoStateType == "DELETE") {
            const { deletedOverlayIndex } = lastUndoState;
            if (overlayKey && overlayData) {
                const currentOverlayData = aiVideoShootsStates?.diy?.overlays?.[overlayKey]?.data || [];
                const targetOverlayRow = currentOverlayData[overlayRowIndex] || {};
                const targetOverlayRowData = targetOverlayRow?.data || [];
                let updatedOverlayRowData = [...targetOverlayRowData];
                updatedOverlayRowData.splice(deletedOverlayIndex, 0, { ...overlayData, isSelected: false });
                const updatedOverlayRow = {
                    ...targetOverlayRow,
                    data: updatedOverlayRowData
                }
                if (overlayKey == "scripts") {
                    let startTime = 0;
                    updatedOverlayRowData = updatedOverlayRowData.map((item, index) => {
                        const updatedItem = {
                            ...item,
                            startTime: startTime,
                            endTime: startTime + (item?.endTime - item?.startTime)
                        }
                        startTime += (item?.endTime - item?.startTime);
                        return updatedItem;
                    });
                    updatedOverlayRow.data = updatedOverlayRowData;
                }
                const updatedOverlayRows = currentOverlayData.map((row, index) => {
                    if (index == overlayRowIndex) {
                        return updatedOverlayRow;
                    }
                    return row;
                })
                const updatedRedoState = {
                    action: "DELETE",
                    overlayKey: overlayKey,
                    overlayData: overlayData,
                    overlayRowIndex: overlayRowIndex,
                    deletedOverlayIndex: deletedOverlayIndex
                }
                setAiVideoShootsStates((prev) => {
                    return {
                        ...prev,
                        diy: {
                            ...prev?.diy,
                            overlays: {
                                ...prev?.diy?.overlays,
                                [overlayKey]: {
                                    ...prev?.diy?.overlays?.[overlayKey],
                                    data: updatedOverlayRows
                                }
                            },
                            undo: currentUndoStates.slice(0, currentUndoStates.length - 1),
                            redo: [...(prev?.diy?.redo || []), updatedRedoState]
                        }
                    }
                })
                handleResetVideoTime();
            }
            else {
                setShowGenericToast({
                    message: "No more undo steps available",
                    status: true,
                    type: "danger"
                });
                return;
            }
        }
        else {
            setShowGenericToast({
                message: "No more undo steps available",
                status: true,
                type: "danger"
            });
            return;
        }
    }
    else {
        setShowGenericToast({
            message: "No more undo steps available",
            status: true,
            type: "danger"
        });
        return;
    }
}

export const handleRedoClick = (aiVideoShootsStates, setAiVideoShootsStates, setShowGenericToast, handleResetVideoTime) => {
    const currentRedoStates = aiVideoShootsStates?.diy?.redo || [];
    if (currentRedoStates?.length > 0) {
        const lastRedoState = currentRedoStates[currentRedoStates.length - 1];
        const redoStateType = lastRedoState?.action || "ADD";
        const { overlayKey, overlayData, overlayRowIndex } = lastRedoState;
        const overlayId = overlayData?.id;
        if (redoStateType == "ADD") {
            if (overlayKey && overlayData) {
                const currentOverlayData = aiVideoShootsStates?.diy?.overlays?.[overlayKey]?.data || [];
                const targetOverlayRow = currentOverlayData[overlayRowIndex] || {};
                const targetOverlayRowData = targetOverlayRow?.data || [];
                const updatedOverlayRowData = [...targetOverlayRowData, { ...overlayData, isSelected: false }];
                const updatedOverlayRow = {
                    ...targetOverlayRow,
                    data: updatedOverlayRowData
                }
                const updatedOverlayRows = currentOverlayData.map((row, index) => {
                    if (index == overlayRowIndex) {
                        return updatedOverlayRow;
                    }
                    return row;
                })
                const updatedUndoState = {
                    action: "ADD",
                    overlayKey: overlayKey,
                    overlayData: overlayData,
                    overlayRowIndex: overlayRowIndex
                }
                setAiVideoShootsStates((prev) => {
                    return {
                        ...prev,
                        diy: {
                            ...prev?.diy,
                            overlays: {
                                ...prev?.diy?.overlays,
                                [overlayKey]: {
                                    ...prev?.diy?.overlays?.[overlayKey],
                                    data: updatedOverlayRows
                                }
                            },
                            undo: [...(prev?.diy?.undo || []), updatedUndoState],
                            redo: currentRedoStates.slice(0, currentRedoStates.length - 1)
                        }
                    }
                })
                handleResetVideoTime();
            }
            else {
                setShowGenericToast({
                    message: "No more redo steps available",
                    status: true,
                    type: "danger"
                });
                return;
            }
        }
        else if (redoStateType == "DELETE") {
            const { deletedOverlayIndex } = lastRedoState;
            if (overlayKey && overlayData) {
                const currentOverlayData = aiVideoShootsStates?.diy?.overlays?.[overlayKey]?.data || [];
                const targetOverlayRow = currentOverlayData[overlayRowIndex] || {};
                const targetOverlayRowData = targetOverlayRow?.data || [];
                const filteredOverlayRowData = targetOverlayRowData.filter((item) => item?.id != overlayId);
                const updatedOverlayRow = {
                    ...targetOverlayRow,
                    data: filteredOverlayRowData
                }
                const updatedOverlayRows = currentOverlayData.map((row, index) => {
                    if (index == overlayRowIndex) {
                        return updatedOverlayRow;
                    }
                    return row;
                })
                const updatedUndoState = {
                    action: "DELETE",
                    overlayKey: overlayKey,
                    overlayData: overlayData,
                    overlayRowIndex: overlayRowIndex,
                    deletedOverlayIndex: deletedOverlayIndex
                }
                setAiVideoShootsStates((prev) => {
                    return {
                        ...prev,
                        diy: {
                            ...prev?.diy,
                            overlays: {
                                ...prev?.diy?.overlays,
                                [overlayKey]: {
                                    ...prev?.diy?.overlays?.[overlayKey],
                                    data: updatedOverlayRows
                                }
                            },
                            undo: [...(prev?.diy?.undo || []), updatedUndoState],
                            redo: currentRedoStates.slice(0, currentRedoStates.length - 1)
                        }
                    }
                })
                handleResetVideoTime();
            }
            else {
                setShowGenericToast({
                    message: "No more redo steps available",
                    status: true,
                    type: "danger"
                });
                return;
            }
        }
        else {
            setShowGenericToast({
                message: "No more redo steps available",
                status: true,
                type: "danger"
            });
            return;
        }
    }
    else {
        setShowGenericToast({
            message: "No more redo steps available",
            status: true,
            type: "danger"
        });
        return;
    }
}

export const findSelectedOverlay = (overlayKey = null, aiVideoShootsStates = {}) => {
    if (!overlayKey) {
        const currentOverlays = aiVideoShootsStates?.diy?.overlays || {};
        for (const key in currentOverlays) {
            const overlayRows = currentOverlays[key]?.data || [];
            for (let i = 0; i < overlayRows.length; i++) {
                const overlayRow = overlayRows[i];
                const overlayDatas = overlayRow?.data || [];
                for (const overlayData of overlayDatas) {
                    if (overlayData?.isSelected) {
                        return {
                            overlayType: key,
                            overlayData: overlayData,
                            overlayRowIndex: i
                        }
                    }
                }
            }
        }
        return null;
    }
    else {
        const currentOverlays = aiVideoShootsStates?.diy?.overlays || {};
        const overlayRows = currentOverlays[overlayKey]?.data || [];
        for (let i = 0; i < overlayRows.length; i++) {
            const overlayRow = overlayRows[i];
            const overlayDatas = overlayRow?.data || [];
            for (const overlayData of overlayDatas) {
                if (overlayData?.isSelected) {
                    return {
                        overlayType: overlayKey,
                        overlayData: overlayData,
                        overlayRowIndex: i
                    }
                }
            }
        }
        return null;
    }
}

export const getMaxEndTimeForOverlay = (duration, speed) => {
    if (speed <= 0) return duration;
    return Math.ceil(duration / speed);
}
export const handleUpdateOverlaySpeed = (
    overlayType,
    overlayRowIndex,
    newSpeed,
    setAiVideoShootsStates,
    aiVideoShootsStates,
    overlayId,
    setShowGenericToast,
    actualBlockTime = 0,
    setLocalScripts = () => { }
) => {
    const overlayRowData = aiVideoShootsStates?.diy?.overlays?.[overlayType]?.data?.[overlayRowIndex]?.data || [];

    const selectedOverlay = overlayRowData.find((overlay) => overlay.id == overlayId);

    if (!selectedOverlay) {
        return {
            updated: false
        }
    }

    const blockMaxEndDuration = getMaxEndTimeForOverlay(actualBlockTime, newSpeed);

    // New end time based on speed change
    let currentMaxEndDuration = getMaxEndTimeForOverlay(
        selectedOverlay.endTime - selectedOverlay.startTime,
        newSpeed
    );

    let currentMaxEndTime = Math.min(currentMaxEndDuration, blockMaxEndDuration);

    // Step 1: Update only the selected overlay first
    let updatedOverlayRowData = overlayRowData.map((overlay) => {
        if (overlay?.id === overlayId) {
            return {
                ...overlay,
                speed: newSpeed,
                endTime: overlay?.startTime + currentMaxEndTime,
                duration: currentMaxEndTime,
                overlayStartTime: 0
            };
        }
        return { ...overlay };
    });

    // Step 2: Sort overlays by start time (timeline order)
    updatedOverlayRowData.sort((a, b) => a.startTime - b.startTime);
    // Step 3: Shift only overlapping FOLLOWING overlays forward
    let lastEndTime = null;

    const finalOverlayRowData = updatedOverlayRowData.map((overlay, index) => {

        const duration = overlay.endTime - overlay.startTime;

        // First overlay remains as is
        if (index === 0) {
            lastEndTime = overlay?.endTime;
            return overlay;
        }

        // If overlap with previous, shift forward
        if (overlay.startTime < lastEndTime) {
            const newStart = lastEndTime;
            const newEnd = newStart + duration;

            lastEndTime = newEnd;

            return {
                ...overlay,
                startTime: newStart,
                endTime: newEnd
            };
        }

        // No overlap → keep as is
        lastEndTime = overlay.endTime;
        return overlay;
    });

    // Step 4: Validate total duration against Max Video Time
    const finalRowEndTime = finalOverlayRowData.reduce(
        (maxEnd, overlay) => Math.max(maxEnd, overlay.endTime),
        0
    );

    if (finalRowEndTime > Max_Video_Time) {
        setShowGenericToast({
            type: "danger",
            message: `Cannot set speed. The total duration of overlays exceeds the maximum allowed video duration of ${Max_Video_Time} seconds.`,
            status: true
        });
        return false;
    }

    if (overlayType == "scripts" && setLocalScripts) {
        setLocalScripts((prev) => {
            const currentScripts = [...prev];
            let updatedOverlayRowData = currentScripts.map((overlay) => {
                if (overlay?.id === overlayId) {
                    return {
                        ...overlay,
                        speed: newSpeed,
                        endTime: overlay?.startTime + currentMaxEndTime,
                        duration: currentMaxEndTime,
                        overlayStartTime: 0
                    };
                }
                return { ...overlay };
            });
            // Step 2: Sort overlays by start time (timeline order)
            updatedOverlayRowData.sort((a, b) => a.startTime - b.startTime);
            // Step 3: Shift only overlapping FOLLOWING overlays forward
            let lastEndTime = null;

            const finalOverlayRowData = updatedOverlayRowData.map((overlay, index) => {

                const duration = overlay.endTime - overlay.startTime;

                // First overlay remains as is
                if (index === 0) {
                    lastEndTime = overlay?.endTime;
                    return overlay;
                }

                // If overlap with previous, shift forward
                if (overlay.startTime < lastEndTime) {
                    const newStart = lastEndTime;
                    const newEnd = newStart + duration;

                    lastEndTime = newEnd;

                    return {
                        ...overlay,
                        startTime: newStart,
                        endTime: newEnd
                    };
                }

                // No overlap → keep as is
                lastEndTime = overlay.endTime;
                return overlay;
            });

            return finalOverlayRowData;
        });
    }

    // Step 5: Save updated overlays into state
    setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
            ...prev?.diy,
            overlays: {
                ...prev?.diy?.overlays,
                [overlayType]: {
                    ...prev?.diy?.overlays?.[overlayType],
                    data: prev?.diy?.overlays?.[overlayType]?.data?.map((row, index) => {
                        if (index === overlayRowIndex) {
                            return {
                                ...row,
                                data: finalOverlayRowData
                            };
                        }
                        return row;
                    })
                }
            }
        }
    }));

    return {
        updated: true,
        updatedEndTime: selectedOverlay?.startTime + currentMaxEndTime,
        updatedDuration: currentMaxEndTime
    }
};

export const getFontsOptions = (vudio = [], custom = []) => {
    let options = [];
    if (custom?.length > 0) {
        options?.push({
            label: <span>Your Fonts</span>,
            title: 'Your Fonts',
            options: custom?.map((fontData) => {
                return {
                    label: <span>{fontData?.font_family}</span>,
                    value: fontData?.font_family
                }
            })
        })
    }
    if (vudio?.length > 0) {
        options?.push({
            label: <span>Vyumi Fonts</span>,
            title: 'Vyumi Fonts',
            options: vudio?.map((fontData) => {
                return {
                    label: <span>{fontData?.name}</span>,
                    value: fontData?.name
                }
            })
        })
    }

    return options;
}

export const getFontsOptionsId = (vudio = [], custom = []) => {
    let options = [];
    if (custom?.length > 0) {
        options?.push({
            label: <span>Your Fonts</span>,
            title: 'Your Fonts',
            options: custom?.map((fontData) => {
                return {
                    label: <span>{fontData?.font_family}</span>,
                    value: fontData?._id
                }
            })
        })
    }
    if (vudio?.length > 0) {
        options?.push({
            label: <span>Vyumi Fonts</span>,
            title: 'Vyumi Fonts',
            options: vudio?.map((fontData) => {
                return {
                    label: <span>{fontData?.displayName}</span>,
                    value: fontData?._id
                }
            })
        })
    }

    return options;
}

export const getDefaultModelId = (platform = "kling", modelsData = []) => {
    const currentModelsData = [...modelsData];
    const fetchedModel = currentModelsData.find((modelData) => modelData.platform == platform);
    if (fetchedModel) {
        const defaultModel = fetchedModel?.models[0];
        if (defaultModel) {
            return defaultModel?.model;
        }
        else {
            return platform == "kling" ? "kling2.1" : "Seeddance1.0Lite";
        }
    }
    else {
        return platform == "kling" ? "kling2.1" : "Seeddance1.0Lite";
    }
}

export const getModelConfigIdWithResolution = (platform = "kling", model_id = null, modelsData = []) => {
    const currentModelsData = [...modelsData];
    const fetchedModel = currentModelsData.find((modelData) => modelData.platform == platform);
    if (fetchedModel) {
        const fetchedModelData = fetchedModel?.models?.find((modelData) => modelData?.model == model_id);
        if (fetchedModelData) {
            const modes = fetchedModelData?.modes ?? {};
            if (modes?.std["720p"]) {
                return {
                    model_config_id: modes?.std["720p"]?.config_id,
                    resolution: "720p",
                    mode: "std"
                }
            }
            else {
                return {
                    model_config_id: modes?.std["1080p"]?.config_id,
                    resolution: "1080p",
                    mode: "std"
                }
            }
        }
        else {
            return {
                model_config_id: platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720",
                resolution: "720p",
                mode: "std"
            }
        }
    }
    else {
        return {
            model_config_id: platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720",
            resolution: "720p",
            mode: "std"
        }
    }
}

export const getSevicesOptions = (modelsData = []) => {
    return modelsData.map((modelData) => {
        return {
            label: modelData?.label,
            value: modelData?.platform
        }
    })
}

export const getModelsOptions = (modelsData = [], platform) => {
    const fetchedService = modelsData.find((modelData) => modelData?.platform == platform);
    if (fetchedService) {
        return fetchedService.models.map((modelData) => {
            return {
                label: modelData?.model_name,
                value: modelData?.model
            }
        })
    }
    else {
        return []
    }
}

export const getModelConfigWithMode = (platform = "kling", model_id = null, mode = "std", modelsData = []) => {
    const currentModelsData = [...modelsData];
    const fetchedModel = currentModelsData.find((modelData) => modelData.platform == platform);
    if (fetchedModel) {
        const fetchedModelData = fetchedModel?.models?.find((modelData) => modelData?.model == model_id);
        if (fetchedModelData) {
            const modes = fetchedModelData?.modes ?? {};
            if (modes[mode]) {
                if (modes?.[mode]?.["720p"]) {
                    return {
                        model_config_id: modes?.[mode]?.["720p"]?.["config_id"],
                        resolution: "720p",
                        mode
                    }
                }
                else {
                    return {
                        model_config_id: modes?.[mode]?.["1080p"]?.["config_id"],
                        resolution: "1080p",
                        mode
                    }
                }
            }
            else {
                return {
                    model_config_id: platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720",
                    resolution: "720p",
                    mode: "std"
                }
            }
        }
        else {
            return {
                model_config_id: platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720",
                resolution: "720p",
                mode: "std"
            }
        }
    }
    else {
        return {
            model_config_id: platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720",
            resolution: "720p",
            mode: "std"
        }
    }
}

export const getModelConfigId = (platform = "kling", model_id = null, mode = "std", resolution = "720p", modelsData = []) => {
    const currentModelsData = [...modelsData];
    const fetchedModel = currentModelsData.find((modelData) => modelData.platform == platform);
    if (fetchedModel) {
        const fetchedModelData = fetchedModel?.models?.find((modelData) => modelData?.model == model_id);
        if (fetchedModelData) {
            const modes = fetchedModelData?.modes ?? {};
            if (modes[mode]) {
                if (modes?.[mode]?.[resolution]) {
                    return modes?.[mode]?.[resolution]?.["config_id"];
                }
                else {
                    return platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720";
                }
            }
            else {
                return platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720";
            }
        }
        else {
            return platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720";
        }
    }
    else {
        return platform == "kling" ? "kling_2_1_720" : "seeddance_1_0_lite_720";
    }
}

export const getResolutionOptions = (platform = "kling", model_id = null, mode = "std", modelsData = []) => {
    const currentModelsData = [...modelsData];
    const fetchedModel = currentModelsData.find((modelData) => modelData.platform == platform);
    if (fetchedModel) {
        const fetchedModelData = fetchedModel?.models?.find((modelData) => modelData?.model == model_id);
        if (fetchedModelData) {
            const modes = fetchedModelData?.modes ?? {};
            if (modes[mode]) {
                let options = [];
                if (modes[mode]?.["720p"]) {
                    options.push({
                        value: "720p",
                        label: "720p",
                    })
                }
                if (modes[mode]?.["1080p"]) {
                    options.push({
                        value: "1080p",
                        label: "1080p",
                    })
                }
                return options;
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }
}

export const getCreditValuePerDuration = (modelsData = [], platform = "kling", model_id = null, mode = "std", resolution = "720p") => {
    const currentModelsData = [...modelsData];
    const fetchedModel = currentModelsData.find((modelData) => modelData.platform == platform);
    if (fetchedModel) {
        const fetchedModelData = fetchedModel?.models?.find((modelData) => modelData?.model == model_id);
        if (fetchedModelData) {
            const modes = fetchedModelData?.modes ?? {};
            if (modes[mode]) {
                if(modes[mode][resolution]){
                    return modes[mode][resolution]["credit"] ?? 1;
                }
                else{
                    return 1;
                }
            }
            else {
                return 1;
            }
        }
        else {
            return 1;
        }
    }
    else {
        return 1;
    }
}